var map = {
	"./crimson-scales/cs-01-orb-of-confusion-back.png": 849287,
	"./crimson-scales/cs-01a-orb-of-confusion.png": 463668,
	"./crimson-scales/cs-01b-orb-of-confusion.png": 927922,
	"./crimson-scales/cs-02-orb-of-momentum-back.png": 272892,
	"./crimson-scales/cs-02a-orb-of-momentum.png": 660352,
	"./crimson-scales/cs-02b-orb-of-momentum.png": 403414,
	"./crimson-scales/cs-03-orb-of-agility-back.png": 864455,
	"./crimson-scales/cs-03a-orb-of-agility.png": 280913,
	"./crimson-scales/cs-03b-orb-of-agility.png": 18974,
	"./crimson-scales/cs-04-orb-of-vigor-back.png": 512196,
	"./crimson-scales/cs-04a-orb-of-vigor.png": 703092,
	"./crimson-scales/cs-04b-orb-of-vigor.png": 54600,
	"./crimson-scales/cs-05-orb-of-retribution-back.png": 804069,
	"./crimson-scales/cs-05a-orb-of-retribution.png": 599158,
	"./crimson-scales/cs-05b-orb-of-retribution.png": 81249,
	"./crimson-scales/cs-06-orb-of-infection-back.png": 215556,
	"./crimson-scales/cs-06a-orb-of-infection.png": 227626,
	"./crimson-scales/cs-06b-orb-of-infection.png": 505272,
	"./crimson-scales/cs-07-orb-of-vitality-back.png": 685194,
	"./crimson-scales/cs-07a-orb-of-vitality.png": 610826,
	"./crimson-scales/cs-07b-orb-of-vitality.png": 67395,
	"./crimson-scales/cs-08-orb-of-protection-back.png": 989933,
	"./crimson-scales/cs-08a-orb-of-protection.png": 934213,
	"./crimson-scales/cs-08b-orb-of-protection.png": 295665,
	"./crimson-scales/cs-09-orb-of-fortune-back.png": 892314,
	"./crimson-scales/cs-09a-orb-of-fortune.png": 719918,
	"./crimson-scales/cs-09b-orb-of-fortune.png": 649554,
	"./crimson-scales/cs-10-orb-of-despair-back.png": 995954,
	"./crimson-scales/cs-100-wonder-stone-back.png": 518310,
	"./crimson-scales/cs-100-wonder-stone.png": 7859,
	"./crimson-scales/cs-10a-orb-of-despair.png": 186389,
	"./crimson-scales/cs-10b-orb-of-despair.png": 410594,
	"./crimson-scales/cs-11-pox-antidote-back.png": 994173,
	"./crimson-scales/cs-11-pox-antidote.png": 809771,
	"./crimson-scales/cs-12-trophy-helm-back.png": 484771,
	"./crimson-scales/cs-12-trophy-helm.png": 815936,
	"./crimson-scales/cs-13-war-pick-back.png": 890227,
	"./crimson-scales/cs-13a-war-pick.png": 526777,
	"./crimson-scales/cs-13b-war-pick.png": 455069,
	"./crimson-scales/cs-14-chain-mace-back.png": 731858,
	"./crimson-scales/cs-14a-chain-mace.png": 797516,
	"./crimson-scales/cs-14b-chain-mace.png": 950442,
	"./crimson-scales/cs-15-draining-greaves-back.png": 168529,
	"./crimson-scales/cs-15a-draining-greaves.png": 2473,
	"./crimson-scales/cs-15b-draining-greaves.png": 270933,
	"./crimson-scales/cs-16-shoes-of-phasing-back.png": 836615,
	"./crimson-scales/cs-16-shoes-of-phasing.png": 348070,
	"./crimson-scales/cs-17-lightweight-boots-back.png": 542314,
	"./crimson-scales/cs-17a-lightweight-boots.png": 999267,
	"./crimson-scales/cs-17b-lightweight-boots.png": 865553,
	"./crimson-scales/cs-18-bottled-moonlight-back.png": 762288,
	"./crimson-scales/cs-18a-bottled-moonlight.png": 49168,
	"./crimson-scales/cs-18b-bottled-moonlight.png": 283339,
	"./crimson-scales/cs-19-boots-of-perpetuity-back.png": 322850,
	"./crimson-scales/cs-19-boots-of-perpetuity.png": 180668,
	"./crimson-scales/cs-20-curious-pendant-back.png": 325858,
	"./crimson-scales/cs-20a-curious-pendant.png": 56033,
	"./crimson-scales/cs-20b-curious-pendant.png": 687829,
	"./crimson-scales/cs-21-infrared-goggles-back.png": 744717,
	"./crimson-scales/cs-21-infrared-goggles.png": 737977,
	"./crimson-scales/cs-22-steel-helmet-back.png": 550583,
	"./crimson-scales/cs-22a-steel-helmet.png": 803859,
	"./crimson-scales/cs-22b-steel-helmet.png": 2612,
	"./crimson-scales/cs-23-woven-plate-armor-back.png": 482098,
	"./crimson-scales/cs-23a-woven-plate-armor.png": 496864,
	"./crimson-scales/cs-23b-woven-plate-armor.png": 386194,
	"./crimson-scales/cs-24-mantle-of-purity-back.png": 1276,
	"./crimson-scales/cs-24a-mantle-of-purity.png": 413145,
	"./crimson-scales/cs-24b-mantle-of-purity.png": 50485,
	"./crimson-scales/cs-25-boneclad-shawl-back.png": 180525,
	"./crimson-scales/cs-25a-boneclad-shawl.png": 268928,
	"./crimson-scales/cs-25b-boneclad-shawl.png": 304598,
	"./crimson-scales/cs-26-silhouette-cuirass-back.png": 598196,
	"./crimson-scales/cs-26-silhouette-cuirass.png": 256969,
	"./crimson-scales/cs-27-translocation-device-back.png": 450454,
	"./crimson-scales/cs-27-translocation-device.png": 435061,
	"./crimson-scales/cs-28-alchemy-potion-back.png": 147217,
	"./crimson-scales/cs-28a-alchemy-potion.png": 282778,
	"./crimson-scales/cs-28b-alchemy-potion.png": 268274,
	"./crimson-scales/cs-29-intoxicating-potion-back.png": 215355,
	"./crimson-scales/cs-29-intoxicating-potion.png": 279393,
	"./crimson-scales/cs-30-iron-snare-back.png": 201832,
	"./crimson-scales/cs-30a-iron-snare.png": 361102,
	"./crimson-scales/cs-30b-iron-snare.png": 315324,
	"./crimson-scales/cs-31-concussion-mine-back.png": 262050,
	"./crimson-scales/cs-31a-concussion-mine.png": 518070,
	"./crimson-scales/cs-31b-concussion-mine.png": 375991,
	"./crimson-scales/cs-32-shifting-compass-back.png": 886377,
	"./crimson-scales/cs-32-shifting-compass.png": 389379,
	"./crimson-scales/cs-33-battering-ram-back.png": 549664,
	"./crimson-scales/cs-33-battering-ram.png": 435085,
	"./crimson-scales/cs-34-claw-trap-back.png": 210367,
	"./crimson-scales/cs-34-claw-trap.png": 278882,
	"./crimson-scales/cs-35-staff-of-retribution-back.png": 321542,
	"./crimson-scales/cs-35-staff-of-retribution.png": 586046,
	"./crimson-scales/cs-36-curseblood-blade-back.png": 84578,
	"./crimson-scales/cs-36-curseblood-blade.png": 837541,
	"./crimson-scales/cs-37-drakescale-shield-back.png": 887513,
	"./crimson-scales/cs-37a-drakescale-shield.png": 713009,
	"./crimson-scales/cs-37b-drakescale-shield.png": 39615,
	"./crimson-scales/cs-38-drakescale-dagger-back.png": 76005,
	"./crimson-scales/cs-38-drakescale-dagger.png": 361644,
	"./crimson-scales/cs-39-hook-shot-back.png": 772088,
	"./crimson-scales/cs-39-hook-shot.png": 338331,
	"./crimson-scales/cs-40-moonleather-boots-back.png": 630950,
	"./crimson-scales/cs-40-moonleather-boots.png": 293587,
	"./crimson-scales/cs-41-spirit-libation-back.png": 483863,
	"./crimson-scales/cs-41-spirit-libation.png": 981723,
	"./crimson-scales/cs-42-robe-of-soothing-back.png": 863308,
	"./crimson-scales/cs-42-robe-of-soothing.png": 237148,
	"./crimson-scales/cs-43-resplendent-mitre-back.png": 207053,
	"./crimson-scales/cs-43-resplendent-mitre.png": 180617,
	"./crimson-scales/cs-44-canister-projectile-back.png": 326552,
	"./crimson-scales/cs-44-canister-projectile.png": 146707,
	"./crimson-scales/cs-45-chain-cannon-back.png": 670758,
	"./crimson-scales/cs-45-chain-cannon.png": 427433,
	"./crimson-scales/cs-46-summoners-whistle-back.png": 547554,
	"./crimson-scales/cs-46-summoners-whistle.png": 842959,
	"./crimson-scales/cs-47-nature-armlets-back.png": 369840,
	"./crimson-scales/cs-47-nature-armlets.png": 51496,
	"./crimson-scales/cs-48-test-tube-back.png": 957068,
	"./crimson-scales/cs-48-test-tube.png": 458791,
	"./crimson-scales/cs-49-booster-shot-back.png": 379570,
	"./crimson-scales/cs-49-booster-shot.png": 745738,
	"./crimson-scales/cs-50-luminous-carapace-back.png": 104499,
	"./crimson-scales/cs-50-luminous-carapace.png": 428901,
	"./crimson-scales/cs-51-flaming-armor-back.png": 591582,
	"./crimson-scales/cs-51-flaming-armor.png": 886942,
	"./crimson-scales/cs-52-flaming-axe-back.png": 466513,
	"./crimson-scales/cs-52-flaming-axe.png": 128876,
	"./crimson-scales/cs-53-field-mortar-back.png": 580784,
	"./crimson-scales/cs-53-field-mortar.png": 25384,
	"./crimson-scales/cs-54-vipertooth-dagger-back.png": 638851,
	"./crimson-scales/cs-54-vipertooth-dagger.png": 314106,
	"./crimson-scales/cs-55-ghost-viper-venom-back.png": 447397,
	"./crimson-scales/cs-55a-ghost-viper-venom.png": 578231,
	"./crimson-scales/cs-55b-ghost-viper-venom.png": 123073,
	"./crimson-scales/cs-56-clamp-trap-back.png": 892233,
	"./crimson-scales/cs-56-clamp-trap.png": 943978,
	"./crimson-scales/cs-57-cleansed-voidheart-back.png": 566021,
	"./crimson-scales/cs-57-cleansed-voidheart.png": 625073,
	"./crimson-scales/cs-58-dizzying-tincture-back.png": 294957,
	"./crimson-scales/cs-58a-dizzying-tincture.png": 677164,
	"./crimson-scales/cs-58b-dizzying-tincture.png": 586772,
	"./crimson-scales/cs-59-drakes-blood-back.png": 166382,
	"./crimson-scales/cs-59a-drakes-blood.png": 517397,
	"./crimson-scales/cs-59b-drakes-blood.png": 77121,
	"./crimson-scales/cs-60-mana-medicine-back.png": 80804,
	"./crimson-scales/cs-60a-mana-medicine.png": 771668,
	"./crimson-scales/cs-60b-mana-medicine.png": 325529,
	"./crimson-scales/cs-61-ashsteel-gauntlets-back.png": 623533,
	"./crimson-scales/cs-61-ashsteel-gauntlets.png": 969814,
	"./crimson-scales/cs-62-smog-emitter-back.png": 78569,
	"./crimson-scales/cs-62-smog-emitter.png": 804291,
	"./crimson-scales/cs-63-lucky-horseshoe-back.png": 206080,
	"./crimson-scales/cs-63-lucky-horseshoe.png": 652079,
	"./crimson-scales/cs-64-mild-kindled-tonic-back.png": 204381,
	"./crimson-scales/cs-64-mild-kindled-tonic.png": 307259,
	"./crimson-scales/cs-65-rescue-axe-back.png": 978080,
	"./crimson-scales/cs-65-rescue-axe.png": 878867,
	"./crimson-scales/cs-66-iron-malleus-back.png": 749084,
	"./crimson-scales/cs-66-iron-malleus.png": 200523,
	"./crimson-scales/cs-67-pike-hook-back.png": 510612,
	"./crimson-scales/cs-67-pike-hook.png": 43176,
	"./crimson-scales/cs-68-explosive-tonic-back.png": 751481,
	"./crimson-scales/cs-68-explosive-tonic.png": 34078,
	"./crimson-scales/cs-69-spicy-kindled-tonic-back.png": 673322,
	"./crimson-scales/cs-69-spicy-kindled-tonic.png": 739630,
	"./crimson-scales/cs-70-utility-rope-back.png": 333724,
	"./crimson-scales/cs-70-utility-rope.png": 99505,
	"./crimson-scales/cs-71-fireproof-helm-back.png": 89563,
	"./crimson-scales/cs-71-fireproof-helm.png": 909402,
	"./crimson-scales/cs-72-wooden-ladder-back.png": 597433,
	"./crimson-scales/cs-72-wooden-ladder.png": 116579,
	"./crimson-scales/cs-73-medical-kit-back.png": 427677,
	"./crimson-scales/cs-73-medical-kit.png": 192757,
	"./crimson-scales/cs-74-mild-bolstering-tonic-back.png": 944933,
	"./crimson-scales/cs-74-mild-bolstering-tonic.png": 970610,
	"./crimson-scales/cs-75-medallion-of-the-oak-back.png": 627844,
	"./crimson-scales/cs-75-medallion-of-the-oak.png": 74909,
	"./crimson-scales/cs-76-cauterizing-knife-back.png": 474623,
	"./crimson-scales/cs-76-cauterizing-knife.png": 151260,
	"./crimson-scales/cs-77-trauma-kit-back.png": 569306,
	"./crimson-scales/cs-77-trauma-kit.png": 219669,
	"./crimson-scales/cs-78-scroll-of-charisma-back.png": 647540,
	"./crimson-scales/cs-78-scroll-of-charisma.png": 960121,
	"./crimson-scales/cs-79-rescue-shield-back.png": 727769,
	"./crimson-scales/cs-79-rescue-shield.png": 500169,
	"./crimson-scales/cs-80-scroll-of-protection-back.png": 975474,
	"./crimson-scales/cs-80-scroll-of-protection.png": 698853,
	"./crimson-scales/cs-81-spicy-bolstering-tonic-back.png": 515611,
	"./crimson-scales/cs-81-spicy-bolstering-tonic.png": 765938,
	"./crimson-scales/cs-82-scroll-of-command-back.png": 793308,
	"./crimson-scales/cs-82-scroll-of-command.png": 446537,
	"./crimson-scales/cs-83-sphere-of-currents-back.png": 114685,
	"./crimson-scales/cs-83-sphere-of-currents.png": 586356,
	"./crimson-scales/cs-84-slug-crossbow-back.png": 344121,
	"./crimson-scales/cs-84-slug-crossbow.png": 769703,
	"./crimson-scales/cs-85-refined-slug-crossbow-back.png": 972553,
	"./crimson-scales/cs-85-refined-slug-crossbow.png": 824199,
	"./crimson-scales/cs-86-bulwark-banner-back.png": 623321,
	"./crimson-scales/cs-86-bulwark-banner.png": 16302,
	"./crimson-scales/cs-87-refined-bulwark-banner-back.png": 569593,
	"./crimson-scales/cs-87-refined-bulwark-banner.png": 785473,
	"./crimson-scales/cs-88-remote-beetle-back.png": 554106,
	"./crimson-scales/cs-88-remote-beetle.png": 852839,
	"./crimson-scales/cs-89-refined-remote-beetle-back.png": 789411,
	"./crimson-scales/cs-89-refined-remote-beetle.png": 720768,
	"./crimson-scales/cs-90-blazing-boots-back.png": 842651,
	"./crimson-scales/cs-90-blazing-boots.png": 136230,
	"./crimson-scales/cs-91-refined-blazing-boots-back.png": 247330,
	"./crimson-scales/cs-91-refined-blazing-boots.png": 938772,
	"./crimson-scales/cs-92-viper-blowgun-back.png": 993041,
	"./crimson-scales/cs-92-viper-blowgun.png": 284590,
	"./crimson-scales/cs-93-refined-viper-blowgun-back.png": 835034,
	"./crimson-scales/cs-93-refined-viper-blowgun.png": 417011,
	"./crimson-scales/cs-94-frost-stone-back.png": 519935,
	"./crimson-scales/cs-94-frost-stone.png": 460178,
	"./crimson-scales/cs-95-storm-stone-back.png": 710522,
	"./crimson-scales/cs-95-storm-stone.png": 280190,
	"./crimson-scales/cs-96-inferno-stone-back.png": 77655,
	"./crimson-scales/cs-96-inferno-stone.png": 900217,
	"./crimson-scales/cs-97-tremor-stone-back.png": 717891,
	"./crimson-scales/cs-97-tremor-stone.png": 361792,
	"./crimson-scales/cs-98-brilliant-stone-back.png": 492992,
	"./crimson-scales/cs-98-brilliant-stone.png": 199284,
	"./crimson-scales/cs-99-dark-stone-back.png": 179655,
	"./crimson-scales/cs-99-dark-stone.png": 706110,
	"./crimson-scales/cs-aa01-rockspine-bulwark-back.png": 923043,
	"./crimson-scales/cs-aa01-rockspine-bulwark.png": 269132,
	"./crimson-scales/cs-aa02-ghostshimmer-honey-back.png": 561606,
	"./crimson-scales/cs-aa02-ghostshimmer-honey.png": 155525,
	"./crimson-scales/cs-aa03-steelsilk-spinneret-back.png": 18604,
	"./crimson-scales/cs-aa03-steelsilk-spinneret.png": 251055,
	"./crimson-scales/cs-qa01-power-modulator-back.png": 219632,
	"./crimson-scales/cs-qa01-power-modulator.png": 21985,
	"./crimson-scales/cs-qa02a-steam-piston-hammer-back.png": 26208,
	"./crimson-scales/cs-qa02a-steam-piston-hammer.png": 497333,
	"./crimson-scales/cs-qa02b-steam-piston-hammer-back.png": 116804,
	"./crimson-scales/cs-qa02b-steam-piston-hammer.png": 196563,
	"./crimson-scales/cs-qa03a-spider-climb-gloves-back.png": 856755,
	"./crimson-scales/cs-qa03a-spider-climb-gloves.png": 561038,
	"./crimson-scales/cs-qa03b-spider-climb-gloves-back.png": 178569,
	"./crimson-scales/cs-qa03b-spider-climb-gloves.png": 472522,
	"./crimson-scales/cs-qa04-gravity-inversion-pads-back.png": 445586,
	"./crimson-scales/cs-qa04-gravity-inversion-pads.png": 557819,
	"./crimson-scales/cs-qa05-delicate-model-back.png": 761830,
	"./crimson-scales/cs-qa05-delicate-model.png": 562286,
	"./crimson-scales/cs-qa06-auscudec-of-the-makers-back.png": 932022,
	"./crimson-scales/cs-qa06-auscudec-of-the-makers.png": 297320,
	"./crimson-scales/cs-rm01-serrated-edge-back.png": 780312,
	"./crimson-scales/cs-rm01a-serrated-edge.png": 673290,
	"./crimson-scales/cs-rm01b-serrated-edge.png": 719560,
	"./crimson-scales/cs-rm02-grisly-boots-back.png": 626769,
	"./crimson-scales/cs-rm02-grisly-boots.png": 195488,
	"./crimson-scales/cs-rm03-terrorscale-saber-back.png": 941652,
	"./crimson-scales/cs-rm03-terrorscale-saber.png": 934080,
	"./crimson-scales/cs-rm04-terrorscale-crossblades-back.png": 255827,
	"./crimson-scales/cs-rm04-terrorscale-crossblades.png": 31124,
	"./crimson-scales/cs-rm05-rite-of-ruin-back.png": 399312,
	"./crimson-scales/cs-rm05-rite-of-ruin.png": 653750,
	"./crimson-scales/cs-rm06-savage-cuirass-back.png": 104703,
	"./crimson-scales/cs-rm06-savage-cuirass.png": 597822,
	"./forgotten-circles/152-165/fc-1036-living-armor-reference-back.png": 661303,
	"./forgotten-circles/152-165/fc-1036-living-armor-reference.png": 285825,
	"./forgotten-circles/152-165/fc-152-ring-of-duality-back.png": 693801,
	"./forgotten-circles/152-165/fc-152-ring-of-duality.png": 525722,
	"./forgotten-circles/152-165/fc-153-minor-antidote-back.png": 254999,
	"./forgotten-circles/152-165/fc-153-minor-antidote.png": 611092,
	"./forgotten-circles/152-165/fc-154-major-antidote-back.png": 174157,
	"./forgotten-circles/152-165/fc-154-major-antidote.png": 713850,
	"./forgotten-circles/152-165/fc-155-curseward-armor-back.png": 161866,
	"./forgotten-circles/152-165/fc-155-curseward-armor.png": 36946,
	"./forgotten-circles/152-165/fc-156-elemental-claymore-back.png": 236482,
	"./forgotten-circles/152-165/fc-156-elemental-claymore.png": 510531,
	"./forgotten-circles/152-165/fc-157-ancient-bow-back.png": 317603,
	"./forgotten-circles/152-165/fc-157-ancient-bow.png": 109988,
	"./forgotten-circles/152-165/fc-158-rejuvenation-greaves-back.png": 894885,
	"./forgotten-circles/152-165/fc-158-rejuvenation-greaves.png": 747876,
	"./forgotten-circles/152-165/fc-159-scroll-of-haste-back.png": 312771,
	"./forgotten-circles/152-165/fc-159-scroll-of-haste.png": 10375,
	"./forgotten-circles/152-165/fc-160-cutpurse-dagger-back.png": 320144,
	"./forgotten-circles/152-165/fc-160-cutpurse-dagger.png": 166165,
	"./forgotten-circles/152-165/fc-161-throwing-axe-back.png": 154308,
	"./forgotten-circles/152-165/fc-161-throwing-axe.png": 922237,
	"./forgotten-circles/152-165/fc-162-rift-device-back.png": 686598,
	"./forgotten-circles/152-165/fc-162-rift-device.png": 675104,
	"./forgotten-circles/152-165/fc-163-crystal-tiara-back.png": 87896,
	"./forgotten-circles/152-165/fc-163-crystal-tiara.png": 839413,
	"./forgotten-circles/152-165/fc-164-basin-of-prophecy-back.png": 976354,
	"./forgotten-circles/152-165/fc-164-basin-of-prophecy.png": 505661,
	"./forgotten-circles/152-165/fc-165-living-armor-back.png": 52733,
	"./forgotten-circles/152-165/fc-165-living-armor.png": 79355,
	"./forgotten-circles/ZZ/zz.txt": 894324,
	"./frosthaven/001-010/fh-001-spyglass-back.png": 775584,
	"./frosthaven/001-010/fh-001-spyglass.png": 342021,
	"./frosthaven/001-010/fh-002-crude-helmet-back.png": 976246,
	"./frosthaven/001-010/fh-002-crude-helmet.png": 113075,
	"./frosthaven/001-010/fh-003-traveling-cloak-back.png": 986866,
	"./frosthaven/001-010/fh-003-traveling-cloak.png": 137685,
	"./frosthaven/001-010/fh-004-crude-hide-armor-back.png": 798234,
	"./frosthaven/001-010/fh-004-crude-hide-armor.png": 108498,
	"./frosthaven/001-010/fh-005-crude-boots-back.png": 62609,
	"./frosthaven/001-010/fh-005-crude-boots.png": 897941,
	"./frosthaven/001-010/fh-006-flexible-slippers-back.png": 673938,
	"./frosthaven/001-010/fh-006-flexible-slippers.png": 915019,
	"./frosthaven/001-010/fh-007-crude-bow-back.png": 225592,
	"./frosthaven/001-010/fh-007-crude-bow.png": 192913,
	"./frosthaven/001-010/fh-008-crude-spear-back.png": 773896,
	"./frosthaven/001-010/fh-008-crude-spear.png": 252253,
	"./frosthaven/001-010/fh-009-protective-scepter-back.png": 206006,
	"./frosthaven/001-010/fh-009-protective-scepter.png": 877375,
	"./frosthaven/001-010/fh-010-crude-shield-back.png": 724714,
	"./frosthaven/001-010/fh-010-crude-shield.png": 151392,
	"./frosthaven/011-015/fh-011-simple-charm-back.png": 307372,
	"./frosthaven/011-015/fh-011-simple-charm.png": 155886,
	"./frosthaven/011-015/fh-012-crude-chain-armor-back.png": 821823,
	"./frosthaven/011-015/fh-012-crude-chain-armor.png": 634933,
	"./frosthaven/011-015/fh-013-dancing-slippers-back.png": 403736,
	"./frosthaven/011-015/fh-013-dancing-slippers.png": 90701,
	"./frosthaven/011-015/fh-014-heavy-sword-back.png": 769228,
	"./frosthaven/011-015/fh-014-heavy-sword.png": 954423,
	"./frosthaven/011-015/fh-015-reinforced-shield-back.png": 337839,
	"./frosthaven/011-015/fh-015-reinforced-shield.png": 494889,
	"./frosthaven/016-020/fh-016-inspiring-helmet-back.png": 849333,
	"./frosthaven/016-020/fh-016-inspiring-helmet.png": 417511,
	"./frosthaven/016-020/fh-017-cured-leather-armor-back.png": 649666,
	"./frosthaven/016-020/fh-017-cured-leather-armor.png": 83807,
	"./frosthaven/016-020/fh-018-rough-boots-back.png": 96830,
	"./frosthaven/016-020/fh-018-rough-boots.png": 367924,
	"./frosthaven/016-020/fh-019-ringing-hammer-back.png": 637346,
	"./frosthaven/016-020/fh-019-ringing-hammer.png": 3089,
	"./frosthaven/016-020/fh-020-well-strung-bow-back.png": 608295,
	"./frosthaven/016-020/fh-020-well-strung-bow.png": 725209,
	"./frosthaven/021-025/fh-021-chain-hood-back.png": 965182,
	"./frosthaven/021-025/fh-021-chain-hood.png": 402236,
	"./frosthaven/021-025/fh-022-heavy-chain-armor-back.png": 605584,
	"./frosthaven/021-025/fh-022-heavy-chain-armor.png": 211329,
	"./frosthaven/021-025/fh-023-sturdy-greaves-back.png": 261806,
	"./frosthaven/021-025/fh-023-sturdy-greaves.png": 393488,
	"./frosthaven/021-025/fh-024-corrupted-blade-back.png": 543824,
	"./frosthaven/021-025/fh-024-corrupted-blade.png": 630940,
	"./frosthaven/021-025/fh-025-soothing-scepter-back.png": 353055,
	"./frosthaven/021-025/fh-025-soothing-scepter.png": 93574,
	"./frosthaven/026-030/fh-026-truesight-lenses-back.png": 699366,
	"./frosthaven/026-030/fh-026-truesight-lenses.png": 797273,
	"./frosthaven/026-030/fh-027-cloak-of-warding-back.png": 724158,
	"./frosthaven/026-030/fh-027-cloak-of-warding.png": 68837,
	"./frosthaven/026-030/fh-028-sturdy-boots-back.png": 479592,
	"./frosthaven/026-030/fh-028-sturdy-boots.png": 251270,
	"./frosthaven/026-030/fh-029-cleaving-axe-back.png": 894174,
	"./frosthaven/026-030/fh-029-cleaving-axe.png": 244849,
	"./frosthaven/026-030/fh-030-parrying-gauntlet-back.png": 776394,
	"./frosthaven/026-030/fh-030-parrying-gauntlet.png": 649714,
	"./frosthaven/031-035/fh-031-deathproof-charm-back.png": 654509,
	"./frosthaven/031-035/fh-031-deathproof-charm.png": 209856,
	"./frosthaven/031-035/fh-032-shell-armor-back.png": 405109,
	"./frosthaven/031-035/fh-032-shell-armor.png": 677342,
	"./frosthaven/031-035/fh-033-volatile-boots-back.png": 485255,
	"./frosthaven/031-035/fh-033-volatile-boots.png": 990816,
	"./frosthaven/031-035/fh-034-shrapnel-bomb-back.png": 903174,
	"./frosthaven/031-035/fh-034-shrapnel-bomb.png": 886130,
	"./frosthaven/031-035/fh-035-kite-shield-back.png": 534802,
	"./frosthaven/031-035/fh-035-kite-shield.png": 135729,
	"./frosthaven/036-040/fh-036-plumed-helmet-back.png": 299662,
	"./frosthaven/036-040/fh-036-plumed-helmet.png": 795450,
	"./frosthaven/036-040/fh-037-ghost-cloak-back.png": 675059,
	"./frosthaven/036-040/fh-037-ghost-cloak.png": 327060,
	"./frosthaven/036-040/fh-038-duelists-shoes-back.png": 980371,
	"./frosthaven/036-040/fh-038-duelists-shoes.png": 207854,
	"./frosthaven/036-040/fh-039-abyss-axe-back.png": 567219,
	"./frosthaven/036-040/fh-039-abyss-axe.png": 204469,
	"./frosthaven/036-040/fh-040-heartstrike-bow-back.png": 404794,
	"./frosthaven/036-040/fh-040-heartstrike-bow.png": 780359,
	"./frosthaven/041-045/fh-041-intricate-charm-back.png": 396291,
	"./frosthaven/041-045/fh-041-intricate-charm.png": 813519,
	"./frosthaven/041-045/fh-042-ornate-armor-back.png": 55536,
	"./frosthaven/041-045/fh-042-ornate-armor.png": 953665,
	"./frosthaven/041-045/fh-043-kicking-boots-back.png": 296495,
	"./frosthaven/041-045/fh-043-kicking-boots.png": 840432,
	"./frosthaven/041-045/fh-044-sword-of-absolution-back.png": 476346,
	"./frosthaven/041-045/fh-044-sword-of-absolution.png": 370125,
	"./frosthaven/041-045/fh-045-master-scepter-back.png": 167646,
	"./frosthaven/041-045/fh-045-master-scepter.png": 13179,
	"./frosthaven/046-050/fh-046-double-lens-goggles-back.png": 431593,
	"./frosthaven/046-050/fh-046-double-lens-goggles.png": 334849,
	"./frosthaven/046-050/fh-047-robes-of-doom-back.png": 12749,
	"./frosthaven/046-050/fh-047-robes-of-doom.png": 971136,
	"./frosthaven/046-050/fh-048-living-shoes-back.png": 756080,
	"./frosthaven/046-050/fh-048-living-shoes.png": 556046,
	"./frosthaven/046-050/fh-049-cruel-dagger-back.png": 495463,
	"./frosthaven/046-050/fh-049-cruel-dagger.png": 525822,
	"./frosthaven/046-050/fh-050-shield-of-reciprocity-back.png": 460111,
	"./frosthaven/046-050/fh-050-shield-of-reciprocity.png": 506681,
	"./frosthaven/051-065/fh-051a-spiked-collar-back.png": 750697,
	"./frosthaven/051-065/fh-051a-spiked-collar.png": 359824,
	"./frosthaven/051-065/fh-051b-spiked-collar-back.png": 980496,
	"./frosthaven/051-065/fh-051b-spiked-collar.png": 207159,
	"./frosthaven/051-065/fh-052a-laser-lens-back.png": 468105,
	"./frosthaven/051-065/fh-052a-laser-lens.png": 873065,
	"./frosthaven/051-065/fh-052b-laser-lens-back.png": 609288,
	"./frosthaven/051-065/fh-052b-laser-lens.png": 445157,
	"./frosthaven/051-065/fh-053a-hobnail-boots-back.png": 131021,
	"./frosthaven/051-065/fh-053a-hobnail-boots.png": 184148,
	"./frosthaven/051-065/fh-053b-hobnail-boots-back.png": 263402,
	"./frosthaven/051-065/fh-053b-hobnail-boots.png": 833240,
	"./frosthaven/051-065/fh-054a-restful-slippers-back.png": 708029,
	"./frosthaven/051-065/fh-054a-restful-slippers.png": 827772,
	"./frosthaven/051-065/fh-054b-restful-slippers-back.png": 650776,
	"./frosthaven/051-065/fh-054b-restful-slippers.png": 229018,
	"./frosthaven/051-065/fh-055a-biting-gauntlet-back.png": 399837,
	"./frosthaven/051-065/fh-055a-biting-gauntlet.png": 9587,
	"./frosthaven/051-065/fh-055b-biting-gauntlet-back.png": 541854,
	"./frosthaven/051-065/fh-055b-biting-gauntlet.png": 657662,
	"./frosthaven/051-065/fh-056a-scavengers-magnet-back.png": 556516,
	"./frosthaven/051-065/fh-056a-scavengers-magnet.png": 648411,
	"./frosthaven/051-065/fh-056b-scavengers-magnet-back.png": 196103,
	"./frosthaven/051-065/fh-056b-scavengers-magnet.png": 347569,
	"./frosthaven/051-065/fh-057a-shovel-back.png": 89154,
	"./frosthaven/051-065/fh-057a-shovel.png": 514324,
	"./frosthaven/051-065/fh-057b-shovel-back.png": 754406,
	"./frosthaven/051-065/fh-057b-shovel.png": 54440,
	"./frosthaven/051-065/fh-058a-slippery-sword-back.png": 839705,
	"./frosthaven/051-065/fh-058a-slippery-sword.png": 52070,
	"./frosthaven/051-065/fh-058b-slippery-sword-back.png": 468357,
	"./frosthaven/051-065/fh-058b-slippery-sword.png": 14586,
	"./frosthaven/051-065/fh-059a-charm-of-expertise-back.png": 937443,
	"./frosthaven/051-065/fh-059a-charm-of-expertise.png": 407774,
	"./frosthaven/051-065/fh-059b-charm-of-expertise-back.png": 831547,
	"./frosthaven/051-065/fh-059b-charm-of-expertise.png": 751278,
	"./frosthaven/051-065/fh-060a-cloak-of-many-pockets-back.png": 410365,
	"./frosthaven/051-065/fh-060a-cloak-of-many-pockets.png": 998309,
	"./frosthaven/051-065/fh-060b-cloak-of-many-pockets-back.png": 681510,
	"./frosthaven/051-065/fh-060b-cloak-of-many-pockets.png": 360649,
	"./frosthaven/051-065/fh-061a-spiked-shell-back.png": 541145,
	"./frosthaven/051-065/fh-061a-spiked-shell.png": 768623,
	"./frosthaven/051-065/fh-061b-spiked-shell-back.png": 439454,
	"./frosthaven/051-065/fh-061b-spiked-shell.png": 943384,
	"./frosthaven/051-065/fh-062a-everlasting-boots-back.png": 51577,
	"./frosthaven/051-065/fh-062a-everlasting-boots.png": 827312,
	"./frosthaven/051-065/fh-062b-everlasting-boots-back.png": 199697,
	"./frosthaven/051-065/fh-062b-everlasting-boots.png": 9294,
	"./frosthaven/051-065/fh-063a-shadow-stompers-back.png": 213285,
	"./frosthaven/051-065/fh-063a-shadow-stompers.png": 588158,
	"./frosthaven/051-065/fh-063b-shadow-stompers-back.png": 731611,
	"./frosthaven/051-065/fh-063b-shadow-stompers.png": 150846,
	"./frosthaven/051-065/fh-064a-detonator-back.png": 45590,
	"./frosthaven/051-065/fh-064a-detonator.png": 188298,
	"./frosthaven/051-065/fh-064b-detonator-back.png": 284620,
	"./frosthaven/051-065/fh-064b-detonator.png": 916581,
	"./frosthaven/051-065/fh-065a-rust-powder-back.png": 462278,
	"./frosthaven/051-065/fh-065a-rust-powder.png": 42136,
	"./frosthaven/051-065/fh-065b-rust-powder-back.png": 109333,
	"./frosthaven/051-065/fh-065b-rust-powder.png": 974125,
	"./frosthaven/066-082/fh-066-amulet-of-eternal-life-back.png": 307720,
	"./frosthaven/066-082/fh-066-amulet-of-eternal-life.png": 725244,
	"./frosthaven/066-082/fh-067-converging-lenses-back.png": 222469,
	"./frosthaven/066-082/fh-067-converging-lenses.png": 801391,
	"./frosthaven/066-082/fh-068-scaled-armor-back.png": 325541,
	"./frosthaven/066-082/fh-068-scaled-armor.png": 528587,
	"./frosthaven/066-082/fh-069-feathered-cloak-back.png": 235095,
	"./frosthaven/066-082/fh-069-feathered-cloak.png": 440662,
	"./frosthaven/066-082/fh-070-aesther-robe-back.png": 609294,
	"./frosthaven/066-082/fh-070-aesther-robe.png": 602401,
	"./frosthaven/066-082/fh-071-bone-boots-back.png": 307818,
	"./frosthaven/066-082/fh-071-bone-boots.png": 997258,
	"./frosthaven/066-082/fh-072-oak-staff-back.png": 114013,
	"./frosthaven/066-082/fh-072-oak-staff.png": 744204,
	"./frosthaven/066-082/fh-073-energizing-baton-back.png": 772633,
	"./frosthaven/066-082/fh-073-energizing-baton.png": 920657,
	"./frosthaven/066-082/fh-074-shock-grenades-back.png": 685428,
	"./frosthaven/066-082/fh-074-shock-grenades.png": 702952,
	"./frosthaven/066-082/fh-075-rose-gauntlet-back.png": 901483,
	"./frosthaven/066-082/fh-075-rose-gauntlet.png": 896410,
	"./frosthaven/066-082/fh-076-horn-of-command-back.png": 577217,
	"./frosthaven/066-082/fh-076-horn-of-command.png": 428078,
	"./frosthaven/066-082/fh-077-chaos-cannon-back.png": 178540,
	"./frosthaven/066-082/fh-077-chaos-cannon.png": 652286,
	"./frosthaven/066-082/fh-078-balanced-scales-back.png": 891091,
	"./frosthaven/066-082/fh-078-balanced-scales.png": 641594,
	"./frosthaven/066-082/fh-079-roasted-fowl-back.png": 579604,
	"./frosthaven/066-082/fh-079-roasted-fowl.png": 577917,
	"./frosthaven/066-082/fh-080-living-stone-back.png": 451480,
	"./frosthaven/066-082/fh-080-living-stone.png": 719721,
	"./frosthaven/066-082/fh-081-pain-simulacrum-back.png": 28415,
	"./frosthaven/066-082/fh-081-pain-simulacrum.png": 809552,
	"./frosthaven/066-082/fh-082-mechanical-cube-back.png": 756942,
	"./frosthaven/066-082/fh-082-mechanical-cube.png": 508043,
	"./frosthaven/083-119/fh-083-healing-potion-back.png": 734617,
	"./frosthaven/083-119/fh-083-healing-potion.png": 249804,
	"./frosthaven/083-119/fh-084-stamina-potion-back.png": 944098,
	"./frosthaven/083-119/fh-084-stamina-potion.png": 360302,
	"./frosthaven/083-119/fh-085-power-potion-back.png": 789618,
	"./frosthaven/083-119/fh-085-power-potion.png": 514138,
	"./frosthaven/083-119/fh-086-element-potion-back.png": 930653,
	"./frosthaven/083-119/fh-086-element-potion.png": 822146,
	"./frosthaven/083-119/fh-087-cure-potion-back.png": 557811,
	"./frosthaven/083-119/fh-087-cure-potion.png": 883884,
	"./frosthaven/083-119/fh-088-fireshield-potion-back.png": 823882,
	"./frosthaven/083-119/fh-088-fireshield-potion.png": 967429,
	"./frosthaven/083-119/fh-089-stoneskin-potion-back.png": 326351,
	"./frosthaven/083-119/fh-089-stoneskin-potion.png": 332603,
	"./frosthaven/083-119/fh-090-muscle-potion-back.png": 764632,
	"./frosthaven/083-119/fh-090-muscle-potion.png": 256786,
	"./frosthaven/083-119/fh-091-holy-water-back.png": 8721,
	"./frosthaven/083-119/fh-091-holy-water.png": 121394,
	"./frosthaven/083-119/fh-092-renewing-potion-back.png": 618856,
	"./frosthaven/083-119/fh-092-renewing-potion.png": 388371,
	"./frosthaven/083-119/fh-093-glancing-potion-back.png": 10871,
	"./frosthaven/083-119/fh-093-glancing-potion.png": 664696,
	"./frosthaven/083-119/fh-094-frenzy-potion-back.png": 448978,
	"./frosthaven/083-119/fh-094-frenzy-potion.png": 997979,
	"./frosthaven/083-119/fh-095-poison-vial-back.png": 259536,
	"./frosthaven/083-119/fh-095-poison-vial.png": 48602,
	"./frosthaven/083-119/fh-096-flame-vial-back.png": 609936,
	"./frosthaven/083-119/fh-096-flame-vial.png": 143578,
	"./frosthaven/083-119/fh-097-explosive-vial-back.png": 976169,
	"./frosthaven/083-119/fh-097-explosive-vial.png": 866073,
	"./frosthaven/083-119/fh-098-unhealthy-mixture-back.png": 885939,
	"./frosthaven/083-119/fh-098-unhealthy-mixture.png": 191489,
	"./frosthaven/083-119/fh-099-major-healing-potion-back.png": 724051,
	"./frosthaven/083-119/fh-099-major-healing-potion.png": 103518,
	"./frosthaven/083-119/fh-100-major-stamina-potion-back.png": 224235,
	"./frosthaven/083-119/fh-100-major-stamina-potion.png": 363654,
	"./frosthaven/083-119/fh-101-major-power-potion-back.png": 180335,
	"./frosthaven/083-119/fh-101-major-power-potion.png": 149872,
	"./frosthaven/083-119/fh-102-major-element-potion-back.png": 127752,
	"./frosthaven/083-119/fh-102-major-element-potion.png": 674123,
	"./frosthaven/083-119/fh-103-major-cure-potion-back.png": 969930,
	"./frosthaven/083-119/fh-103-major-cure-potion.png": 676311,
	"./frosthaven/083-119/fh-104-swiftness-potion-back.png": 979713,
	"./frosthaven/083-119/fh-104-swiftness-potion.png": 759650,
	"./frosthaven/083-119/fh-105-major-fireshield-potion-back.png": 467548,
	"./frosthaven/083-119/fh-105-major-fireshield-potion.png": 992804,
	"./frosthaven/083-119/fh-106-stonewall-potion-back.png": 956861,
	"./frosthaven/083-119/fh-106-stonewall-potion.png": 884351,
	"./frosthaven/083-119/fh-107-vigor-potion-back.png": 408721,
	"./frosthaven/083-119/fh-107-vigor-potion.png": 555843,
	"./frosthaven/083-119/fh-108-holy-rain-back.png": 91809,
	"./frosthaven/083-119/fh-108-holy-rain.png": 220899,
	"./frosthaven/083-119/fh-109-major-renewing-potion-back.png": 246121,
	"./frosthaven/083-119/fh-109-major-renewing-potion.png": 650260,
	"./frosthaven/083-119/fh-110-precision-potion-back.png": 665509,
	"./frosthaven/083-119/fh-110-precision-potion.png": 981026,
	"./frosthaven/083-119/fh-111-major-frenzy-potion-back.png": 340153,
	"./frosthaven/083-119/fh-111-major-frenzy-potion.png": 469631,
	"./frosthaven/083-119/fh-112-hammer-potion-back.png": 251954,
	"./frosthaven/083-119/fh-112-hammer-potion.png": 408740,
	"./frosthaven/083-119/fh-113-expertise-potion-back.png": 224093,
	"./frosthaven/083-119/fh-113-expertise-potion.png": 679337,
	"./frosthaven/083-119/fh-114-foresight-potion-back.png": 185386,
	"./frosthaven/083-119/fh-114-foresight-potion.png": 747098,
	"./frosthaven/083-119/fh-115-infusion-potion-back.png": 961329,
	"./frosthaven/083-119/fh-115-infusion-potion.png": 418211,
	"./frosthaven/083-119/fh-116-plague-flask-back.png": 815697,
	"./frosthaven/083-119/fh-116-plague-flask.png": 374770,
	"./frosthaven/083-119/fh-117-inferno-flask-back.png": 90715,
	"./frosthaven/083-119/fh-117-inferno-flask.png": 994793,
	"./frosthaven/083-119/fh-118-fulminant-flask-back.png": 881314,
	"./frosthaven/083-119/fh-118-fulminant-flask.png": 655273,
	"./frosthaven/083-119/fh-119-deadly-mixture-back.png": 564177,
	"./frosthaven/083-119/fh-119-deadly-mixture.png": 566593,
	"./frosthaven/120-128/fh-120-amulet-of-life-back.png": 114060,
	"./frosthaven/120-128/fh-120-amulet-of-life.png": 752811,
	"./frosthaven/120-128/fh-121-circlet-of-elements-back.png": 390560,
	"./frosthaven/120-128/fh-121-circlet-of-elements.png": 513209,
	"./frosthaven/120-128/fh-122-wardens-robes-back.png": 105624,
	"./frosthaven/120-128/fh-122-wardens-robes.png": 929302,
	"./frosthaven/120-128/fh-123-leather-armor-back.png": 457281,
	"./frosthaven/120-128/fh-123-leather-armor.png": 739691,
	"./frosthaven/120-128/fh-124-winged-shoes-back.png": 538560,
	"./frosthaven/120-128/fh-124-winged-shoes.png": 543489,
	"./frosthaven/120-128/fh-125-boots-of-speed-back.png": 970566,
	"./frosthaven/120-128/fh-125-boots-of-speed.png": 857154,
	"./frosthaven/120-128/fh-126-weighted-net-back.png": 256470,
	"./frosthaven/120-128/fh-126-weighted-net.png": 129102,
	"./frosthaven/120-128/fh-127-poison-dagger-back.png": 670259,
	"./frosthaven/120-128/fh-127-poison-dagger.png": 541349,
	"./frosthaven/120-128/fh-128-heater-shield-back.png": 746208,
	"./frosthaven/120-128/fh-128-heater-shield.png": 513047,
	"./frosthaven/129-167/fh-129-eagle-eye-goggles-back.png": 703041,
	"./frosthaven/129-167/fh-129-eagle-eye-goggles.png": 986653,
	"./frosthaven/129-167/fh-130-iron-helmet-back.png": 169453,
	"./frosthaven/129-167/fh-130-iron-helmet.png": 972323,
	"./frosthaven/129-167/fh-131-chainmail-back.png": 719627,
	"./frosthaven/129-167/fh-131-chainmail.png": 983118,
	"./frosthaven/129-167/fh-132-cloak-of-pockets-back.png": 894519,
	"./frosthaven/129-167/fh-132-cloak-of-pockets.png": 745583,
	"./frosthaven/129-167/fh-133-nimble-legguards-back.png": 275278,
	"./frosthaven/129-167/fh-133-nimble-legguards.png": 414073,
	"./frosthaven/129-167/fh-134-comfortable-shoes-back.png": 76197,
	"./frosthaven/129-167/fh-134-comfortable-shoes.png": 474032,
	"./frosthaven/129-167/fh-135-armorbane-bow-back.png": 501340,
	"./frosthaven/129-167/fh-135-armorbane-bow.png": 334555,
	"./frosthaven/129-167/fh-136-battle-axe-back.png": 61103,
	"./frosthaven/129-167/fh-136-battle-axe.png": 159220,
	"./frosthaven/129-167/fh-137-tower-shield-back.png": 975992,
	"./frosthaven/129-167/fh-137-tower-shield.png": 991277,
	"./frosthaven/129-167/fh-138-heavy-basinet-back.png": 118306,
	"./frosthaven/129-167/fh-138-heavy-basinet.png": 757607,
	"./frosthaven/129-167/fh-139-horned-helm-back.png": 876365,
	"./frosthaven/129-167/fh-139-horned-helm.png": 932904,
	"./frosthaven/129-167/fh-140-mantle-of-summoning-back.png": 49041,
	"./frosthaven/129-167/fh-140-mantle-of-summoning.png": 218189,
	"./frosthaven/129-167/fh-141-studded-leather-back.png": 4496,
	"./frosthaven/129-167/fh-141-studded-leather.png": 825142,
	"./frosthaven/129-167/fh-142-boots-of-quickness-back.png": 380507,
	"./frosthaven/129-167/fh-142-boots-of-quickness.png": 776958,
	"./frosthaven/129-167/fh-143-endurance-footwraps-back.png": 995965,
	"./frosthaven/129-167/fh-143-endurance-footwraps.png": 701726,
	"./frosthaven/129-167/fh-144-staff-of-eminence-back.png": 698223,
	"./frosthaven/129-167/fh-144-staff-of-eminence.png": 77136,
	"./frosthaven/129-167/fh-145-versatile-dagger-back.png": 225098,
	"./frosthaven/129-167/fh-145-versatile-dagger.png": 299133,
	"./frosthaven/129-167/fh-146-hooked-chain-back.png": 705558,
	"./frosthaven/129-167/fh-146-hooked-chain.png": 78800,
	"./frosthaven/129-167/fh-147-mask-of-terror-back.png": 245334,
	"./frosthaven/129-167/fh-147-mask-of-terror.png": 992795,
	"./frosthaven/129-167/fh-148-circlet-of-sanctity-back.png": 946905,
	"./frosthaven/129-167/fh-148-circlet-of-sanctity.png": 749835,
	"./frosthaven/129-167/fh-149-platemail-back.png": 836114,
	"./frosthaven/129-167/fh-149-platemail.png": 515154,
	"./frosthaven/129-167/fh-150-robes-of-the-oak-back.png": 8702,
	"./frosthaven/129-167/fh-150-robes-of-the-oak.png": 638078,
	"./frosthaven/129-167/fh-151-serene-sandals-back.png": 700741,
	"./frosthaven/129-167/fh-151-serene-sandals.png": 724082,
	"./frosthaven/129-167/fh-152-steel-sabatons-back.png": 892999,
	"./frosthaven/129-167/fh-152-steel-sabatons.png": 851788,
	"./frosthaven/129-167/fh-153-long-spear-back.png": 947926,
	"./frosthaven/129-167/fh-153-long-spear.png": 250653,
	"./frosthaven/129-167/fh-154-volatile-bomb-back.png": 14752,
	"./frosthaven/129-167/fh-154-volatile-bomb.png": 72545,
	"./frosthaven/129-167/fh-155-wall-shield-back.png": 206000,
	"./frosthaven/129-167/fh-155-wall-shield.png": 588278,
	"./frosthaven/129-167/fh-156-moon-earring-back.png": 700444,
	"./frosthaven/129-167/fh-156-moon-earring.png": 763077,
	"./frosthaven/129-167/fh-157-steel-ring-back.png": 574744,
	"./frosthaven/129-167/fh-157-steel-ring.png": 39030,
	"./frosthaven/129-167/fh-158-deep-earth-brooch-back.png": 451280,
	"./frosthaven/129-167/fh-158-deep-earth-brooch.png": 591781,
	"./frosthaven/129-167/fh-159-glorious-bracelet-back.png": 745944,
	"./frosthaven/129-167/fh-159-glorious-bracelet.png": 424252,
	"./frosthaven/129-167/fh-160-sun-earring-back.png": 659575,
	"./frosthaven/129-167/fh-160-sun-earring.png": 639957,
	"./frosthaven/129-167/fh-161-strategists-ring-back.png": 643530,
	"./frosthaven/129-167/fh-161-strategists-ring.png": 549058,
	"./frosthaven/129-167/fh-162-howling-ice-brooch-back.png": 903152,
	"./frosthaven/129-167/fh-162-howling-ice-brooch.png": 70156,
	"./frosthaven/129-167/fh-163-stunning-bracelet-back.png": 94520,
	"./frosthaven/129-167/fh-163-stunning-bracelet.png": 692040,
	"./frosthaven/129-167/fh-164-star-earring-back.png": 381373,
	"./frosthaven/129-167/fh-164-star-earring.png": 191298,
	"./frosthaven/129-167/fh-165-ring-of-haste-back.png": 109380,
	"./frosthaven/129-167/fh-165-ring-of-haste.png": 705614,
	"./frosthaven/129-167/fh-166-blazing-sun-brooch-back.png": 699417,
	"./frosthaven/129-167/fh-166-blazing-sun-brooch.png": 624643,
	"./frosthaven/129-167/fh-167-attractive-bracelet-back.png": 111958,
	"./frosthaven/129-167/fh-167-attractive-bracelet.png": 465856,
	"./frosthaven/168-192/fh-168-circlet-of-eyes-back.png": 673070,
	"./frosthaven/168-192/fh-168-circlet-of-eyes.png": 928152,
	"./frosthaven/168-192/fh-169-fateful-charm-back.png": 668088,
	"./frosthaven/168-192/fh-169-fateful-charm.png": 462973,
	"./frosthaven/168-192/fh-170-eye-of-truth-back.png": 457150,
	"./frosthaven/168-192/fh-170-eye-of-truth.png": 662841,
	"./frosthaven/168-192/fh-171-rejuvenating-charm-back.png": 816102,
	"./frosthaven/168-192/fh-171-rejuvenating-charm.png": 67066,
	"./frosthaven/168-192/fh-172-cap-of-premonition-back.png": 451285,
	"./frosthaven/168-192/fh-172-cap-of-premonition.png": 760121,
	"./frosthaven/168-192/fh-173-multi-colored-cloak-back.png": 673094,
	"./frosthaven/168-192/fh-173-multi-colored-cloak.png": 26048,
	"./frosthaven/168-192/fh-174-magnetic-cape-back.png": 773929,
	"./frosthaven/168-192/fh-174-magnetic-cape.png": 609775,
	"./frosthaven/168-192/fh-175-mirrored-armor-back.png": 984442,
	"./frosthaven/168-192/fh-175-mirrored-armor.png": 786516,
	"./frosthaven/168-192/fh-176-blinking-cape-back.png": 830643,
	"./frosthaven/168-192/fh-176-blinking-cape.png": 622958,
	"./frosthaven/168-192/fh-177-boots-of-transference-back.png": 85030,
	"./frosthaven/168-192/fh-177-boots-of-transference.png": 247791,
	"./frosthaven/168-192/fh-178-tranquil-shoes-back.png": 270851,
	"./frosthaven/168-192/fh-178-tranquil-shoes.png": 315426,
	"./frosthaven/168-192/fh-179-burst-boots-back.png": 882809,
	"./frosthaven/168-192/fh-179-burst-boots.png": 373027,
	"./frosthaven/168-192/fh-180-boots-of-greed-back.png": 63811,
	"./frosthaven/168-192/fh-180-boots-of-greed.png": 767017,
	"./frosthaven/168-192/fh-181-translocation-rod-back.png": 853953,
	"./frosthaven/168-192/fh-181-translocation-rod.png": 308837,
	"./frosthaven/168-192/fh-182-wing-clippers-back.png": 81081,
	"./frosthaven/168-192/fh-182-wing-clippers.png": 778324,
	"./frosthaven/168-192/fh-183-decanter-of-mists-back.png": 932923,
	"./frosthaven/168-192/fh-183-decanter-of-mists.png": 917987,
	"./frosthaven/168-192/fh-184-flashing-axe-back.png": 63363,
	"./frosthaven/168-192/fh-184-flashing-axe.png": 462595,
	"./frosthaven/168-192/fh-185-mirrored-knife-back.png": 42456,
	"./frosthaven/168-192/fh-185-mirrored-knife.png": 33218,
	"./frosthaven/168-192/fh-186-wild-growth-seeds-back.png": 92734,
	"./frosthaven/168-192/fh-186-wild-growth-seeds.png": 551295,
	"./frosthaven/168-192/fh-187-dangerous-gear-back.png": 883330,
	"./frosthaven/168-192/fh-187-dangerous-gear.png": 937668,
	"./frosthaven/168-192/fh-188-freezing-crystal-back.png": 948484,
	"./frosthaven/168-192/fh-188-freezing-crystal.png": 605064,
	"./frosthaven/168-192/fh-189-ring-of-the-night-back.png": 752474,
	"./frosthaven/168-192/fh-189-ring-of-the-night.png": 411644,
	"./frosthaven/168-192/fh-190-white-card-back.png": 12981,
	"./frosthaven/168-192/fh-190-white-card.png": 248370,
	"./frosthaven/168-192/fh-191-corrupted-scroll-back.png": 246333,
	"./frosthaven/168-192/fh-191-corrupted-scroll.png": 408578,
	"./frosthaven/168-192/fh-192-enticing-bell-back.png": 615235,
	"./frosthaven/168-192/fh-192-enticing-bell.png": 418705,
	"./frosthaven/193-247/fh-193-mind-thieving-helmet-back.png": 566053,
	"./frosthaven/193-247/fh-193-mind-thieving-helmet.png": 747512,
	"./frosthaven/193-247/fh-194-temporal-amulet-back.png": 485836,
	"./frosthaven/193-247/fh-194-temporal-amulet.png": 973897,
	"./frosthaven/193-247/fh-195-tri-corner-hat-back.png": 706341,
	"./frosthaven/193-247/fh-195-tri-corner-hat.png": 394650,
	"./frosthaven/193-247/fh-196-choker-of-sacrifice-back.png": 583537,
	"./frosthaven/193-247/fh-196-choker-of-sacrifice.png": 450789,
	"./frosthaven/193-247/fh-197-aesther-diadem-back.png": 19518,
	"./frosthaven/193-247/fh-197-aesther-diadem.png": 487094,
	"./frosthaven/193-247/fh-198-hunters-necklace-back.png": 854807,
	"./frosthaven/193-247/fh-198-hunters-necklace.png": 106116,
	"./frosthaven/193-247/fh-199-opulent-shoes-back.png": 302611,
	"./frosthaven/193-247/fh-199-opulent-shoes.png": 429867,
	"./frosthaven/193-247/fh-200-eventide-scepter-back.png": 139800,
	"./frosthaven/193-247/fh-200-eventide-scepter.png": 558806,
	"./frosthaven/193-247/fh-201-wave-blade-back.png": 913980,
	"./frosthaven/193-247/fh-201-wave-blade.png": 222657,
	"./frosthaven/193-247/fh-202-giant-piranha-pig-spine-back.png": 758256,
	"./frosthaven/193-247/fh-202-giant-piranha-pig-spine.png": 457762,
	"./frosthaven/193-247/fh-203-scepter-of-control-back.png": 59144,
	"./frosthaven/193-247/fh-203-scepter-of-control.png": 126129,
	"./frosthaven/193-247/fh-204-severed-claw-back.png": 872021,
	"./frosthaven/193-247/fh-204-severed-claw.png": 600314,
	"./frosthaven/193-247/fh-205-harpoon-back.png": 615856,
	"./frosthaven/193-247/fh-205-harpoon.png": 60121,
	"./frosthaven/193-247/fh-206-giant-sword-back.png": 914062,
	"./frosthaven/193-247/fh-206-giant-sword.png": 620926,
	"./frosthaven/193-247/fh-207-fishhook-back.png": 867955,
	"./frosthaven/193-247/fh-207-fishhook.png": 368061,
	"./frosthaven/193-247/fh-208-titan-nail-back.png": 985453,
	"./frosthaven/193-247/fh-208-titan-nail.png": 627387,
	"./frosthaven/193-247/fh-209-sword-of-mastery-back.png": 271329,
	"./frosthaven/193-247/fh-209-sword-of-mastery.png": 919597,
	"./frosthaven/193-247/fh-210-tanjo-back.png": 889467,
	"./frosthaven/193-247/fh-210-tanjo.png": 293399,
	"./frosthaven/193-247/fh-211-boom-barrel-back.png": 69716,
	"./frosthaven/193-247/fh-211-boom-barrel.png": 523832,
	"./frosthaven/193-247/fh-212-elemental-stone-back.png": 616376,
	"./frosthaven/193-247/fh-212-elemental-stone.png": 25829,
	"./frosthaven/193-247/fh-213-key-of-seasons-back.png": 435840,
	"./frosthaven/193-247/fh-213-key-of-seasons.png": 310266,
	"./frosthaven/193-247/fh-214-cup-of-ventillion-back.png": 582683,
	"./frosthaven/193-247/fh-214-cup-of-ventillion.png": 160580,
	"./frosthaven/193-247/fh-215-befuddling-mug-back.png": 712166,
	"./frosthaven/193-247/fh-215-befuddling-mug.png": 888603,
	"./frosthaven/193-247/fh-216-tome-of-elements-back.png": 158289,
	"./frosthaven/193-247/fh-216-tome-of-elements.png": 351964,
	"./frosthaven/193-247/fh-217-tome-of-time-back.png": 912516,
	"./frosthaven/193-247/fh-217-tome-of-time.png": 201530,
	"./frosthaven/193-247/fh-218-tome-of-life-back.png": 575438,
	"./frosthaven/193-247/fh-218-tome-of-life.png": 848685,
	"./frosthaven/193-247/fh-219-tome-of-conflict-back.png": 165937,
	"./frosthaven/193-247/fh-219-tome-of-conflict.png": 531183,
	"./frosthaven/193-247/fh-220-belaras-quill-back.png": 103170,
	"./frosthaven/193-247/fh-220-belaras-quill.png": 313240,
	"./frosthaven/193-247/fh-221-ice-shiv-back.png": 911189,
	"./frosthaven/193-247/fh-221-ice-shiv.png": 158298,
	"./frosthaven/193-247/fh-222-black-box-back.png": 930367,
	"./frosthaven/193-247/fh-222-black-box.png": 648751,
	"./frosthaven/193-247/fh-223-lightning-rod-back.png": 756683,
	"./frosthaven/193-247/fh-223-lightning-rod.png": 754118,
	"./frosthaven/193-247/fh-224-armor-of-empathy-back.png": 372388,
	"./frosthaven/193-247/fh-224-armor-of-empathy.png": 980650,
	"./frosthaven/193-247/fh-225-algox-carving-back.png": 367318,
	"./frosthaven/193-247/fh-225-algox-carving.png": 780981,
	"./frosthaven/193-247/fh-226-unfettered-arm-back.png": 620086,
	"./frosthaven/193-247/fh-226-unfettered-arm.png": 720380,
	"./frosthaven/193-247/fh-227-data-drive-back.png": 574402,
	"./frosthaven/193-247/fh-227-data-drive.png": 547669,
	"./frosthaven/193-247/fh-228-extendable-pole-back.png": 83358,
	"./frosthaven/193-247/fh-228-extendable-pole.png": 325572,
	"./frosthaven/193-247/fh-229-exquisite-map-back.png": 224432,
	"./frosthaven/193-247/fh-229-exquisite-map.png": 683607,
	"./frosthaven/193-247/fh-230-examination-glass-back.png": 939422,
	"./frosthaven/193-247/fh-230-examination-glass.png": 97796,
	"./frosthaven/193-247/fh-231-skinning-knife-back.png": 226946,
	"./frosthaven/193-247/fh-231-skinning-knife.png": 981259,
	"./frosthaven/193-247/fh-232-orchid-wand-back.png": 671352,
	"./frosthaven/193-247/fh-232-orchid-wand.png": 343945,
	"./frosthaven/193-247/fh-233-dead-raven-back.png": 394045,
	"./frosthaven/193-247/fh-233-dead-raven.png": 166811,
	"./frosthaven/193-247/fh-234-ooze-vial-back.png": 918325,
	"./frosthaven/193-247/fh-234-ooze-vial.png": 442776,
	"./frosthaven/193-247/fh-235-small-rat-back.png": 280425,
	"./frosthaven/193-247/fh-235-small-rat.png": 661630,
	"./frosthaven/193-247/fh-236-cracked-mirror-back.png": 355447,
	"./frosthaven/193-247/fh-236-cracked-mirror.png": 941650,
	"./frosthaven/193-247/fh-237-mesmerizing-seashell-back.png": 67946,
	"./frosthaven/193-247/fh-237-mesmerizing-seashell.png": 724302,
	"./frosthaven/193-247/fh-238-cracked-idol-back.png": 451686,
	"./frosthaven/193-247/fh-238-cracked-idol.png": 110446,
	"./frosthaven/193-247/fh-239-eye-of-the-storm-back.png": 211987,
	"./frosthaven/193-247/fh-239-eye-of-the-storm.png": 478025,
	"./frosthaven/193-247/fh-240-demons-gem-back.png": 821408,
	"./frosthaven/193-247/fh-240-demons-gem.png": 604340,
	"./frosthaven/193-247/fh-241-shimmering-powder-back.png": 855894,
	"./frosthaven/193-247/fh-241-shimmering-powder.png": 390619,
	"./frosthaven/193-247/fh-242-lucky-dice-back.png": 402343,
	"./frosthaven/193-247/fh-242-lucky-dice.png": 229338,
	"./frosthaven/193-247/fh-243-cursed-rock-back.png": 265148,
	"./frosthaven/193-247/fh-243-cursed-rock.png": 304469,
	"./frosthaven/193-247/fh-244-ember-energy-source-back.png": 37197,
	"./frosthaven/193-247/fh-244-ember-energy-source.png": 346684,
	"./frosthaven/193-247/fh-245a-ancient-coin-back.png": 367099,
	"./frosthaven/193-247/fh-245a-ancient-coin.png": 980342,
	"./frosthaven/193-247/fh-245b-ancient-coin-back.png": 438266,
	"./frosthaven/193-247/fh-245b-ancient-coin.png": 45354,
	"./frosthaven/193-247/fh-245c-ancient-coin-back.png": 671390,
	"./frosthaven/193-247/fh-245c-ancient-coin.png": 507585,
	"./frosthaven/193-247/fh-245d-ancient-coin-back.png": 795604,
	"./frosthaven/193-247/fh-245d-ancient-coin.png": 813530,
	"./frosthaven/193-247/fh-246-key-card-back.png": 969075,
	"./frosthaven/193-247/fh-246-key-card.png": 216394,
	"./frosthaven/193-247/fh-247-trainers-net-back.png": 825876,
	"./frosthaven/193-247/fh-247-trainers-net.png": 441531,
	"./frosthaven/248-264/fh-248-wanderers-club-back.png": 911574,
	"./frosthaven/248-264/fh-248-wanderers-club.png": 629867,
	"./frosthaven/248-264/fh-249-recalibration-trigger-back.png": 105482,
	"./frosthaven/248-264/fh-249-recalibration-trigger.png": 310161,
	"./frosthaven/248-264/fh-250-spear-of-justice-back.png": 309254,
	"./frosthaven/248-264/fh-250-spear-of-justice.png": 7330,
	"./frosthaven/248-264/fh-251-soul-urn-back.png": 135917,
	"./frosthaven/248-264/fh-251-soul-urn.png": 986694,
	"./frosthaven/248-264/fh-252-black-earth-codex-back.png": 64080,
	"./frosthaven/248-264/fh-252-black-earth-codex.png": 474464,
	"./frosthaven/248-264/fh-253-mask-of-duality-back.png": 928178,
	"./frosthaven/248-264/fh-253-mask-of-duality.png": 391847,
	"./frosthaven/248-264/fh-254-ancestral-blade-back.png": 141371,
	"./frosthaven/248-264/fh-254-ancestral-blade.png": 568660,
	"./frosthaven/248-264/fh-255-mountains-heart-back.png": 256646,
	"./frosthaven/248-264/fh-255-mountains-heart.png": 702035,
	"./frosthaven/248-264/fh-256-sonorous-shard-back.png": 119258,
	"./frosthaven/248-264/fh-256-sonorous-shard.png": 433205,
	"./frosthaven/248-264/fh-257-sly-camouflage-back.png": 754925,
	"./frosthaven/248-264/fh-257-sly-camouflage.png": 330257,
	"./frosthaven/248-264/fh-258-skull-of-agony-back.png": 884247,
	"./frosthaven/248-264/fh-258-skull-of-agony.png": 583389,
	"./frosthaven/248-264/fh-259-storm-carving-back.png": 905111,
	"./frosthaven/248-264/fh-259-storm-carving.png": 367823,
	"./frosthaven/248-264/fh-260-freezing-orb-back.png": 113878,
	"./frosthaven/248-264/fh-260-freezing-orb.png": 209378,
	"./frosthaven/248-264/fh-261-energized-module-back.png": 671430,
	"./frosthaven/248-264/fh-261-energized-module.png": 654829,
	"./frosthaven/248-264/fh-262-exhaust-boots-back.png": 860554,
	"./frosthaven/248-264/fh-262-exhaust-boots.png": 534441,
	"./frosthaven/248-264/fh-263-warlords-skull-back.png": 895725,
	"./frosthaven/248-264/fh-263-warlords-skull.png": 652546,
	"./frosthaven/248-264/fh-264-spiraled-medallion-back.png": 821275,
	"./frosthaven/248-264/fh-264-spiraled-medallion.png": 35578,
	"./gloomhaven/1-14/gh-001-boots-of-striding-back.png": 508306,
	"./gloomhaven/1-14/gh-001-boots-of-striding.png": 834020,
	"./gloomhaven/1-14/gh-002-winged-shoes-back.png": 403006,
	"./gloomhaven/1-14/gh-002-winged-shoes.png": 783450,
	"./gloomhaven/1-14/gh-003-hide-armor-back.png": 646622,
	"./gloomhaven/1-14/gh-003-hide-armor.png": 368023,
	"./gloomhaven/1-14/gh-004-leather-armor-back.png": 245961,
	"./gloomhaven/1-14/gh-004-leather-armor.png": 168311,
	"./gloomhaven/1-14/gh-005-cloak-of-invisibility-back.png": 414784,
	"./gloomhaven/1-14/gh-005-cloak-of-invisibility.png": 710613,
	"./gloomhaven/1-14/gh-006-eagle-eye-goggles-back.png": 882253,
	"./gloomhaven/1-14/gh-006-eagle-eye-goggles.png": 924136,
	"./gloomhaven/1-14/gh-007-iron-helmet-back.png": 260350,
	"./gloomhaven/1-14/gh-007-iron-helmet.png": 802972,
	"./gloomhaven/1-14/gh-008-heater-shield-back.png": 330048,
	"./gloomhaven/1-14/gh-008-heater-shield.png": 466087,
	"./gloomhaven/1-14/gh-009-piercing-bow-back.png": 45716,
	"./gloomhaven/1-14/gh-009-piercing-bow.png": 85622,
	"./gloomhaven/1-14/gh-010-war-hammer-back.png": 880331,
	"./gloomhaven/1-14/gh-010-war-hammer.png": 489000,
	"./gloomhaven/1-14/gh-011-poison-dagger-back.png": 373162,
	"./gloomhaven/1-14/gh-011-poison-dagger.png": 657640,
	"./gloomhaven/1-14/gh-012-minor-healing-potion-back.png": 825104,
	"./gloomhaven/1-14/gh-012-minor-healing-potion.png": 596705,
	"./gloomhaven/1-14/gh-013-minor-stamina-potion-back.png": 469687,
	"./gloomhaven/1-14/gh-013-minor-stamina-potion.png": 935014,
	"./gloomhaven/1-14/gh-014-minor-power-potion-back.png": 825287,
	"./gloomhaven/1-14/gh-014-minor-power-potion.png": 725249,
	"./gloomhaven/15-21/gh-015-boots-of-speed-back.png": 111627,
	"./gloomhaven/15-21/gh-015-boots-of-speed.png": 825469,
	"./gloomhaven/15-21/gh-016-cloak-of-pockets-back.png": 3798,
	"./gloomhaven/15-21/gh-016-cloak-of-pockets.png": 391225,
	"./gloomhaven/15-21/gh-017-empowering-talisman-back.png": 707371,
	"./gloomhaven/15-21/gh-017-empowering-talisman.png": 213554,
	"./gloomhaven/15-21/gh-018-battle-axe-back.png": 284323,
	"./gloomhaven/15-21/gh-018-battle-axe.png": 116002,
	"./gloomhaven/15-21/gh-019-weighted-net-back.png": 13414,
	"./gloomhaven/15-21/gh-019-weighted-net.png": 803681,
	"./gloomhaven/15-21/gh-020-minor-mana-potion-back.png": 404753,
	"./gloomhaven/15-21/gh-020-minor-mana-potion.png": 985877,
	"./gloomhaven/15-21/gh-021-stun-powder-back.png": 890502,
	"./gloomhaven/15-21/gh-021-stun-powder.png": 857861,
	"./gloomhaven/22-28/gh-022-heavy-greaves-back.png": 946376,
	"./gloomhaven/22-28/gh-022-heavy-greaves.png": 807194,
	"./gloomhaven/22-28/gh-023-chainmail-back.png": 450176,
	"./gloomhaven/22-28/gh-023-chainmail.png": 957361,
	"./gloomhaven/22-28/gh-024-amulet-of-life-back.png": 983406,
	"./gloomhaven/22-28/gh-024-amulet-of-life.png": 360705,
	"./gloomhaven/22-28/gh-025-jagged-sword-back.png": 591170,
	"./gloomhaven/22-28/gh-025-jagged-sword.png": 148483,
	"./gloomhaven/22-28/gh-026-long-spear-back.png": 990193,
	"./gloomhaven/22-28/gh-026-long-spear.png": 177345,
	"./gloomhaven/22-28/gh-027-major-healing-potion-back.png": 704186,
	"./gloomhaven/22-28/gh-027-major-healing-potion.png": 355512,
	"./gloomhaven/22-28/gh-028-moon-earring-back.png": 792513,
	"./gloomhaven/22-28/gh-028-moon-earring.png": 745437,
	"./gloomhaven/29-35/gh-029-comfortable-shoes-back.png": 490524,
	"./gloomhaven/29-35/gh-029-comfortable-shoes.png": 999838,
	"./gloomhaven/29-35/gh-030-studded-leather-back.png": 3690,
	"./gloomhaven/29-35/gh-030-studded-leather.png": 784172,
	"./gloomhaven/29-35/gh-031-hawk-helm-back.png": 173002,
	"./gloomhaven/29-35/gh-031-hawk-helm.png": 148658,
	"./gloomhaven/29-35/gh-032-tower-shield-back.png": 173390,
	"./gloomhaven/29-35/gh-032-tower-shield.png": 484879,
	"./gloomhaven/29-35/gh-033-volatile-bomb-back.png": 80634,
	"./gloomhaven/29-35/gh-033-volatile-bomb.png": 90253,
	"./gloomhaven/29-35/gh-034-major-stamina-potion-back.png": 186199,
	"./gloomhaven/29-35/gh-034-major-stamina-potion.png": 751593,
	"./gloomhaven/29-35/gh-035-falcon-figurine-back.png": 519201,
	"./gloomhaven/29-35/gh-035-falcon-figurine.png": 536747,
	"./gloomhaven/36-42/gh-036-boots-of-dashing-back.png": 845825,
	"./gloomhaven/36-42/gh-036-boots-of-dashing.png": 440113,
	"./gloomhaven/36-42/gh-037-robes-of-evocation-back.png": 842737,
	"./gloomhaven/36-42/gh-037-robes-of-evocation.png": 331913,
	"./gloomhaven/36-42/gh-038-heavy-basinet-back.png": 941401,
	"./gloomhaven/36-42/gh-038-heavy-basinet.png": 98986,
	"./gloomhaven/36-42/gh-039-hooked-chain-back.png": 410041,
	"./gloomhaven/36-42/gh-039-hooked-chain.png": 163855,
	"./gloomhaven/36-42/gh-040-versatile-dagger-back.png": 569905,
	"./gloomhaven/36-42/gh-040-versatile-dagger.png": 327085,
	"./gloomhaven/36-42/gh-041-major-power-potion-back.png": 548374,
	"./gloomhaven/36-42/gh-041-major-power-potion.png": 40456,
	"./gloomhaven/36-42/gh-042-ring-of-haste-back.png": 33685,
	"./gloomhaven/36-42/gh-042-ring-of-haste.png": 295859,
	"./gloomhaven/43-49/gh-043-boots-of-quickness-back.png": 546906,
	"./gloomhaven/43-49/gh-043-boots-of-quickness.png": 747503,
	"./gloomhaven/43-49/gh-044-splintmail-back.png": 506557,
	"./gloomhaven/43-49/gh-044-splintmail.png": 504654,
	"./gloomhaven/43-49/gh-045-pendant-of-dark-pacts-back.png": 13970,
	"./gloomhaven/43-49/gh-045-pendant-of-dark-pacts.png": 937554,
	"./gloomhaven/43-49/gh-046-spiked-shield-back.png": 669255,
	"./gloomhaven/43-49/gh-046-spiked-shield.png": 933999,
	"./gloomhaven/43-49/gh-047-reaping-scythe-back.png": 397296,
	"./gloomhaven/43-49/gh-047-reaping-scythe.png": 494848,
	"./gloomhaven/43-49/gh-048-major-mana-potion-back.png": 833190,
	"./gloomhaven/43-49/gh-048-major-mana-potion.png": 828186,
	"./gloomhaven/43-49/gh-049-sun-earring-back.png": 976875,
	"./gloomhaven/43-49/gh-049-sun-earring.png": 438859,
	"./gloomhaven/50-56/gh-050-steel-sabatons-back.png": 619231,
	"./gloomhaven/50-56/gh-050-steel-sabatons.png": 843943,
	"./gloomhaven/50-56/gh-051-shadow-armor-back.png": 219704,
	"./gloomhaven/50-56/gh-051-shadow-armor.png": 753484,
	"./gloomhaven/50-56/gh-052-protective-charm-back.png": 757282,
	"./gloomhaven/50-56/gh-052-protective-charm.png": 109745,
	"./gloomhaven/50-56/gh-053-black-knife-back.png": 715908,
	"./gloomhaven/50-56/gh-053-black-knife.png": 849399,
	"./gloomhaven/50-56/gh-054-staff-of-eminence-back.png": 433415,
	"./gloomhaven/50-56/gh-054-staff-of-eminence.png": 589391,
	"./gloomhaven/50-56/gh-055-super-healing-potion-back.png": 314293,
	"./gloomhaven/50-56/gh-055-super-healing-potion.png": 53173,
	"./gloomhaven/50-56/gh-056-ring-of-brutality-back.png": 938844,
	"./gloomhaven/50-56/gh-056-ring-of-brutality.png": 589607,
	"./gloomhaven/57-63/gh-057-serene-sandals-back.png": 257138,
	"./gloomhaven/57-63/gh-057-serene-sandals.png": 924650,
	"./gloomhaven/57-63/gh-058-cloak-of-phasing-back.png": 840362,
	"./gloomhaven/57-63/gh-058-cloak-of-phasing.png": 846863,
	"./gloomhaven/57-63/gh-059-telescopic-lens-back.png": 542384,
	"./gloomhaven/57-63/gh-059-telescopic-lens.png": 835119,
	"./gloomhaven/57-63/gh-060-unstable-explosives-back.png": 226982,
	"./gloomhaven/57-63/gh-060-unstable-explosives.png": 930024,
	"./gloomhaven/57-63/gh-061-wall-shield-back.png": 694377,
	"./gloomhaven/57-63/gh-061-wall-shield.png": 488411,
	"./gloomhaven/57-63/gh-062-doom-powder-back.png": 627757,
	"./gloomhaven/57-63/gh-062-doom-powder.png": 769755,
	"./gloomhaven/57-63/gh-063-lucky-eye-back.png": 346999,
	"./gloomhaven/57-63/gh-063-lucky-eye.png": 437101,
	"./gloomhaven/64-151/gh-064-boots-of-sprinting-back.png": 366235,
	"./gloomhaven/64-151/gh-064-boots-of-sprinting.png": 324323,
	"./gloomhaven/64-151/gh-065-platemail-back.png": 177770,
	"./gloomhaven/64-151/gh-065-platemail.png": 416649,
	"./gloomhaven/64-151/gh-066-mask-of-terror-back.png": 427002,
	"./gloomhaven/64-151/gh-066-mask-of-terror.png": 280971,
	"./gloomhaven/64-151/gh-067-balanced-blade-back.png": 363150,
	"./gloomhaven/64-151/gh-067-balanced-blade.png": 597366,
	"./gloomhaven/64-151/gh-068-halberd-back.png": 343054,
	"./gloomhaven/64-151/gh-068-halberd.png": 932534,
	"./gloomhaven/64-151/gh-069-star-earring-back.png": 515783,
	"./gloomhaven/64-151/gh-069-star-earring.png": 581919,
	"./gloomhaven/64-151/gh-070-second-chance-ring-back.png": 203919,
	"./gloomhaven/64-151/gh-070-second-chance-ring.png": 547130,
	"./gloomhaven/64-151/gh-071a-boots-of-levitation-back.png": 355834,
	"./gloomhaven/64-151/gh-071a-boots-of-levitation.png": 821212,
	"./gloomhaven/64-151/gh-071b-boots-of-levitation-back.png": 429241,
	"./gloomhaven/64-151/gh-071b-boots-of-levitation.png": 815199,
	"./gloomhaven/64-151/gh-072a-shoes-of-happiness-back.png": 499716,
	"./gloomhaven/64-151/gh-072a-shoes-of-happiness.png": 283726,
	"./gloomhaven/64-151/gh-072b-shoes-of-happiness-back.png": 577175,
	"./gloomhaven/64-151/gh-072b-shoes-of-happiness.png": 510645,
	"./gloomhaven/64-151/gh-073a-blinking-cape-back.png": 844849,
	"./gloomhaven/64-151/gh-073a-blinking-cape.png": 920270,
	"./gloomhaven/64-151/gh-073b-blinking-cape-back.png": 875441,
	"./gloomhaven/64-151/gh-073b-blinking-cape.png": 388306,
	"./gloomhaven/64-151/gh-074a-swordedge-armor-back.png": 473181,
	"./gloomhaven/64-151/gh-074a-swordedge-armor.png": 586854,
	"./gloomhaven/64-151/gh-074b-swordedge-armor-back.png": 505650,
	"./gloomhaven/64-151/gh-074b-swordedge-armor.png": 508295,
	"./gloomhaven/64-151/gh-075a-circlet-of-elements-back.png": 637714,
	"./gloomhaven/64-151/gh-075a-circlet-of-elements.png": 806191,
	"./gloomhaven/64-151/gh-075b-circlet-of-elements-back.png": 962913,
	"./gloomhaven/64-151/gh-075b-circlet-of-elements.png": 52181,
	"./gloomhaven/64-151/gh-076a-chain-hood-back.png": 89897,
	"./gloomhaven/64-151/gh-076a-chain-hood.png": 612724,
	"./gloomhaven/64-151/gh-076b-chain-hood-back.png": 476697,
	"./gloomhaven/64-151/gh-076b-chain-hood.png": 224513,
	"./gloomhaven/64-151/gh-077a-frigid-blade-back.png": 460366,
	"./gloomhaven/64-151/gh-077a-frigid-blade.png": 128381,
	"./gloomhaven/64-151/gh-077b-frigid-blade-back.png": 129214,
	"./gloomhaven/64-151/gh-077b-frigid-blade.png": 596150,
	"./gloomhaven/64-151/gh-078a-storm-blade-back.png": 91439,
	"./gloomhaven/64-151/gh-078a-storm-blade.png": 3473,
	"./gloomhaven/64-151/gh-078b-storm-blade-back.png": 825858,
	"./gloomhaven/64-151/gh-078b-storm-blade.png": 147075,
	"./gloomhaven/64-151/gh-079a-inferno-blade-back.png": 111051,
	"./gloomhaven/64-151/gh-079a-inferno-blade.png": 185017,
	"./gloomhaven/64-151/gh-079b-inferno-blade-back.png": 134895,
	"./gloomhaven/64-151/gh-079b-inferno-blade.png": 890066,
	"./gloomhaven/64-151/gh-080a-tremor-blade-back.png": 707057,
	"./gloomhaven/64-151/gh-080a-tremor-blade.png": 561566,
	"./gloomhaven/64-151/gh-080b-tremor-blade-back.png": 426160,
	"./gloomhaven/64-151/gh-080b-tremor-blade.png": 210373,
	"./gloomhaven/64-151/gh-081a-brilliant-blade-back.png": 720046,
	"./gloomhaven/64-151/gh-081a-brilliant-blade.png": 527891,
	"./gloomhaven/64-151/gh-081b-brilliant-blade-back.png": 166847,
	"./gloomhaven/64-151/gh-081b-brilliant-blade.png": 592480,
	"./gloomhaven/64-151/gh-082a-night-blade-back.png": 857376,
	"./gloomhaven/64-151/gh-082a-night-blade.png": 481761,
	"./gloomhaven/64-151/gh-082b-night-blade-back.png": 275542,
	"./gloomhaven/64-151/gh-082b-night-blade.png": 527331,
	"./gloomhaven/64-151/gh-083a-wand-of-frost-back.png": 67412,
	"./gloomhaven/64-151/gh-083a-wand-of-frost.png": 738693,
	"./gloomhaven/64-151/gh-083b-wand-of-frost-back.png": 12792,
	"./gloomhaven/64-151/gh-083b-wand-of-frost.png": 221966,
	"./gloomhaven/64-151/gh-084a-wand-of-storms-back.png": 444673,
	"./gloomhaven/64-151/gh-084a-wand-of-storms.png": 224859,
	"./gloomhaven/64-151/gh-084b-wand-of-storms-back.png": 285729,
	"./gloomhaven/64-151/gh-084b-wand-of-storms.png": 566079,
	"./gloomhaven/64-151/gh-085a-wand-of-infernos-back.png": 7146,
	"./gloomhaven/64-151/gh-085a-wand-of-infernos.png": 674129,
	"./gloomhaven/64-151/gh-085b-wand-of-infernos-back.png": 954237,
	"./gloomhaven/64-151/gh-085b-wand-of-infernos.png": 335987,
	"./gloomhaven/64-151/gh-086a-wand-of-tremors-back.png": 246321,
	"./gloomhaven/64-151/gh-086a-wand-of-tremors.png": 951323,
	"./gloomhaven/64-151/gh-086b-wand-of-tremors-back.png": 878426,
	"./gloomhaven/64-151/gh-086b-wand-of-tremors.png": 529311,
	"./gloomhaven/64-151/gh-087a-wand-of-brilliance-back.png": 556576,
	"./gloomhaven/64-151/gh-087a-wand-of-brilliance.png": 691779,
	"./gloomhaven/64-151/gh-087b-wand-of-brilliance-back.png": 667569,
	"./gloomhaven/64-151/gh-087b-wand-of-brilliance.png": 495502,
	"./gloomhaven/64-151/gh-088a-wand-of-darkness-back.png": 211163,
	"./gloomhaven/64-151/gh-088a-wand-of-darkness.png": 658074,
	"./gloomhaven/64-151/gh-088b-wand-of-darkness-back.png": 22174,
	"./gloomhaven/64-151/gh-088b-wand-of-darkness.png": 312290,
	"./gloomhaven/64-151/gh-089a-minor-cure-potion-back.png": 225773,
	"./gloomhaven/64-151/gh-089a-minor-cure-potion.png": 287716,
	"./gloomhaven/64-151/gh-089b-minor-cure-potion-back.png": 34318,
	"./gloomhaven/64-151/gh-089b-minor-cure-potion.png": 192314,
	"./gloomhaven/64-151/gh-090a-major-cure-potion-back.png": 147431,
	"./gloomhaven/64-151/gh-090a-major-cure-potion.png": 559538,
	"./gloomhaven/64-151/gh-090b-major-cure-potion-back.png": 162805,
	"./gloomhaven/64-151/gh-090b-major-cure-potion.png": 284904,
	"./gloomhaven/64-151/gh-091a-steel-ring-back.png": 83072,
	"./gloomhaven/64-151/gh-091a-steel-ring.png": 933764,
	"./gloomhaven/64-151/gh-091b-steel-ring-back.png": 184501,
	"./gloomhaven/64-151/gh-091b-steel-ring.png": 54430,
	"./gloomhaven/64-151/gh-092a-dampening-ring-back.png": 932423,
	"./gloomhaven/64-151/gh-092a-dampening-ring.png": 114782,
	"./gloomhaven/64-151/gh-092b-dampening-ring-back.png": 666073,
	"./gloomhaven/64-151/gh-092b-dampening-ring.png": 782668,
	"./gloomhaven/64-151/gh-093a-scroll-of-power-back.png": 706507,
	"./gloomhaven/64-151/gh-093a-scroll-of-power.png": 387538,
	"./gloomhaven/64-151/gh-093b-scroll-of-power-back.png": 717867,
	"./gloomhaven/64-151/gh-093b-scroll-of-power.png": 616224,
	"./gloomhaven/64-151/gh-094a-scroll-of-healing-back.png": 738842,
	"./gloomhaven/64-151/gh-094a-scroll-of-healing.png": 945101,
	"./gloomhaven/64-151/gh-094b-scroll-of-healing-back.png": 764400,
	"./gloomhaven/64-151/gh-094b-scroll-of-healing.png": 462561,
	"./gloomhaven/64-151/gh-095a-scroll-of-stamina-back.png": 498027,
	"./gloomhaven/64-151/gh-095a-scroll-of-stamina.png": 917131,
	"./gloomhaven/64-151/gh-095b-scroll-of-stamina-back.png": 409611,
	"./gloomhaven/64-151/gh-095b-scroll-of-stamina.png": 810062,
	"./gloomhaven/64-151/gh-096-rocket-boots-back.png": 141022,
	"./gloomhaven/64-151/gh-096-rocket-boots.png": 185996,
	"./gloomhaven/64-151/gh-097-endurance-footwraps-back.png": 455425,
	"./gloomhaven/64-151/gh-097-endurance-footwraps.png": 695382,
	"./gloomhaven/64-151/gh-098-drakescale-boots-back.png": 619954,
	"./gloomhaven/64-151/gh-098-drakescale-boots.png": 597170,
	"./gloomhaven/64-151/gh-099-magma-waders-back.png": 690017,
	"./gloomhaven/64-151/gh-099-magma-waders.png": 916911,
	"./gloomhaven/64-151/gh-100-robes-of-summoning-back.png": 673247,
	"./gloomhaven/64-151/gh-100-robes-of-summoning.png": 529521,
	"./gloomhaven/64-151/gh-101-second-skin-back.png": 390406,
	"./gloomhaven/64-151/gh-101-second-skin.png": 392179,
	"./gloomhaven/64-151/gh-102-sacrificial-robes-back.png": 122415,
	"./gloomhaven/64-151/gh-102-sacrificial-robes.png": 863485,
	"./gloomhaven/64-151/gh-103-drakescale-armor-back.png": 553927,
	"./gloomhaven/64-151/gh-103-drakescale-armor.png": 111022,
	"./gloomhaven/64-151/gh-104-steam-armor-back.png": 268315,
	"./gloomhaven/64-151/gh-104-steam-armor.png": 540630,
	"./gloomhaven/64-151/gh-105-flea-bitten-shawl-back.png": 620405,
	"./gloomhaven/64-151/gh-105-flea-bitten-shawl.png": 392992,
	"./gloomhaven/64-151/gh-106-necklace-of-teeth-back.png": 162782,
	"./gloomhaven/64-151/gh-106-necklace-of-teeth.png": 847516,
	"./gloomhaven/64-151/gh-107-horned-helm-back.png": 806903,
	"./gloomhaven/64-151/gh-107-horned-helm.png": 345897,
	"./gloomhaven/64-151/gh-108-drakescale-helm-back.png": 511466,
	"./gloomhaven/64-151/gh-108-drakescale-helm.png": 602925,
	"./gloomhaven/64-151/gh-109-thiefs-hood-back.png": 142641,
	"./gloomhaven/64-151/gh-109-thiefs-hood.png": 123089,
	"./gloomhaven/64-151/gh-110-helm-of-the-mountain-back.png": 877161,
	"./gloomhaven/64-151/gh-110-helm-of-the-mountain.png": 729066,
	"./gloomhaven/64-151/gh-111-wave-crest-back.png": 775615,
	"./gloomhaven/64-151/gh-111-wave-crest.png": 625214,
	"./gloomhaven/64-151/gh-112-ancient-drill-back.png": 782612,
	"./gloomhaven/64-151/gh-112-ancient-drill.png": 837867,
	"./gloomhaven/64-151/gh-113-skullbane-axe-back.png": 466249,
	"./gloomhaven/64-151/gh-113-skullbane-axe.png": 358632,
	"./gloomhaven/64-151/gh-114-staff-of-xorn-back.png": 544736,
	"./gloomhaven/64-151/gh-114-staff-of-xorn.png": 116019,
	"./gloomhaven/64-151/gh-115-mountain-hammer-back.png": 718735,
	"./gloomhaven/64-151/gh-115-mountain-hammer.png": 658774,
	"./gloomhaven/64-151/gh-116-fueled-falchion-back.png": 305954,
	"./gloomhaven/64-151/gh-116-fueled-falchion.png": 965025,
	"./gloomhaven/64-151/gh-117-bloody-axe-back.png": 424637,
	"./gloomhaven/64-151/gh-117-bloody-axe.png": 499189,
	"./gloomhaven/64-151/gh-118-staff-of-elements-back.png": 11277,
	"./gloomhaven/64-151/gh-118-staff-of-elements.png": 613166,
	"./gloomhaven/64-151/gh-119-skull-of-hatred-back.png": 64541,
	"./gloomhaven/64-151/gh-119-skull-of-hatred.png": 527764,
	"./gloomhaven/64-151/gh-120-staff-of-summoning-back.png": 443847,
	"./gloomhaven/64-151/gh-120-staff-of-summoning.png": 905095,
	"./gloomhaven/64-151/gh-121-orb-of-dawn-back.png": 516475,
	"./gloomhaven/64-151/gh-121-orb-of-dawn.png": 211456,
	"./gloomhaven/64-151/gh-122-orb-of-twilight-back.png": 825210,
	"./gloomhaven/64-151/gh-122-orb-of-twilight.png": 777970,
	"./gloomhaven/64-151/gh-123-ring-of-skulls-back.png": 106078,
	"./gloomhaven/64-151/gh-123-ring-of-skulls.png": 20921,
	"./gloomhaven/64-151/gh-124-doomed-compass-back.png": 194753,
	"./gloomhaven/64-151/gh-124-doomed-compass.png": 290607,
	"./gloomhaven/64-151/gh-125-curious-gear-back.png": 913204,
	"./gloomhaven/64-151/gh-125-curious-gear.png": 194363,
	"./gloomhaven/64-151/gh-126-remote-spider-back.png": 262565,
	"./gloomhaven/64-151/gh-126-remote-spider.png": 821020,
	"./gloomhaven/64-151/gh-127-giant-remote-spider-back.png": 559978,
	"./gloomhaven/64-151/gh-127-giant-remote-spider.png": 713645,
	"./gloomhaven/64-151/gh-128-black-censer-back.png": 695686,
	"./gloomhaven/64-151/gh-128-black-censer.png": 445050,
	"./gloomhaven/64-151/gh-129-black-card-back.png": 516819,
	"./gloomhaven/64-151/gh-129-black-card.png": 658394,
	"./gloomhaven/64-151/gh-130-helix-ring-back.png": 605286,
	"./gloomhaven/64-151/gh-130-helix-ring.png": 860221,
	"./gloomhaven/64-151/gh-131-heart-of-the-betrayer-back.png": 293833,
	"./gloomhaven/64-151/gh-131-heart-of-the-betrayer.png": 366509,
	"./gloomhaven/64-151/gh-132-power-core-back.png": 715522,
	"./gloomhaven/64-151/gh-132-power-core.png": 896066,
	"./gloomhaven/64-151/gh-133-resonant-crystal-back.png": 385020,
	"./gloomhaven/64-151/gh-133-resonant-crystal.png": 470010,
	"./gloomhaven/64-151/gh-134-imposing-blade-back.png": 900930,
	"./gloomhaven/64-151/gh-134-imposing-blade.png": 139437,
	"./gloomhaven/64-151/gh-135-focusing-ray-back.png": 895301,
	"./gloomhaven/64-151/gh-135-focusing-ray.png": 834850,
	"./gloomhaven/64-151/gh-136-volatile-elixir-back.png": 419959,
	"./gloomhaven/64-151/gh-136-volatile-elixir.png": 817600,
	"./gloomhaven/64-151/gh-137-silent-stiletto-back.png": 64265,
	"./gloomhaven/64-151/gh-137-silent-stiletto.png": 51367,
	"./gloomhaven/64-151/gh-138-stone-charm-back.png": 682205,
	"./gloomhaven/64-151/gh-138-stone-charm.png": 576515,
	"./gloomhaven/64-151/gh-139-psychic-knife-back.png": 619876,
	"./gloomhaven/64-151/gh-139-psychic-knife.png": 293805,
	"./gloomhaven/64-151/gh-140-sun-shield-back.png": 707181,
	"./gloomhaven/64-151/gh-140-sun-shield.png": 57224,
	"./gloomhaven/64-151/gh-141-utility-belt-back.png": 747909,
	"./gloomhaven/64-151/gh-141-utility-belt.png": 97973,
	"./gloomhaven/64-151/gh-142-phasing-idol-back.png": 618825,
	"./gloomhaven/64-151/gh-142-phasing-idol.png": 167265,
	"./gloomhaven/64-151/gh-143-smoke-elixir-back.png": 113670,
	"./gloomhaven/64-151/gh-143-smoke-elixir.png": 707505,
	"./gloomhaven/64-151/gh-144-pendant-of-the-plague-back.png": 350530,
	"./gloomhaven/64-151/gh-144-pendant-of-the-plague.png": 58628,
	"./gloomhaven/64-151/gh-145-mask-of-death-back.png": 762087,
	"./gloomhaven/64-151/gh-145-mask-of-death.png": 309260,
	"./gloomhaven/64-151/gh-146-masters-lute-back.png": 230676,
	"./gloomhaven/64-151/gh-146-masters-lute.png": 69751,
	"./gloomhaven/64-151/gh-147-cloak-of-the-hunter-back.png": 614208,
	"./gloomhaven/64-151/gh-147-cloak-of-the-hunter.png": 522439,
	"./gloomhaven/64-151/gh-148-doctors-coat-back.png": 902986,
	"./gloomhaven/64-151/gh-148-doctors-coat.png": 44424,
	"./gloomhaven/64-151/gh-149-elemental-boots-back.png": 442923,
	"./gloomhaven/64-151/gh-149-elemental-boots.png": 150448,
	"./gloomhaven/64-151/gh-150-staff-of-command-back.png": 566406,
	"./gloomhaven/64-151/gh-150-staff-of-command.png": 599010,
	"./gloomhaven/64-151/gh-151-sword-of-the-sands-back.png": 907537,
	"./gloomhaven/64-151/gh-151-sword-of-the-sands.png": 534878,
	"./jaws-of-the-lion/1-13/jl-01-eagle-eye-goggles-back.png": 204636,
	"./jaws-of-the-lion/1-13/jl-01-eagle-eye-goggles.png": 113098,
	"./jaws-of-the-lion/1-13/jl-02-iron-helmet-back.png": 375147,
	"./jaws-of-the-lion/1-13/jl-02-iron-helmet.png": 755493,
	"./jaws-of-the-lion/1-13/jl-03-chain-armor-back.png": 660438,
	"./jaws-of-the-lion/1-13/jl-03-chain-armor.png": 610685,
	"./jaws-of-the-lion/1-13/jl-04-studded-leather-back.png": 362859,
	"./jaws-of-the-lion/1-13/jl-04-studded-leather.png": 523958,
	"./jaws-of-the-lion/1-13/jl-05-weathered-boots-back.png": 851632,
	"./jaws-of-the-lion/1-13/jl-05-weathered-boots.png": 778227,
	"./jaws-of-the-lion/1-13/jl-06-winged-shoes-back.png": 984921,
	"./jaws-of-the-lion/1-13/jl-06-winged-shoes.png": 391571,
	"./jaws-of-the-lion/1-13/jl-07-heater-shield-back.png": 887227,
	"./jaws-of-the-lion/1-13/jl-07-heater-shield.png": 901563,
	"./jaws-of-the-lion/1-13/jl-08-throwing-hammer-back.png": 61156,
	"./jaws-of-the-lion/1-13/jl-08-throwing-hammer.png": 914550,
	"./jaws-of-the-lion/1-13/jl-09-poison-dagger-back.png": 24091,
	"./jaws-of-the-lion/1-13/jl-09-poison-dagger.png": 546652,
	"./jaws-of-the-lion/1-13/jl-10-iron-spear-back.png": 926459,
	"./jaws-of-the-lion/1-13/jl-10-iron-spear.png": 287561,
	"./jaws-of-the-lion/1-13/jl-11-healing-potion-back.png": 940115,
	"./jaws-of-the-lion/1-13/jl-11-healing-potion.png": 174303,
	"./jaws-of-the-lion/1-13/jl-12-stamina-potion-back.png": 838170,
	"./jaws-of-the-lion/1-13/jl-12-stamina-potion.png": 383187,
	"./jaws-of-the-lion/1-13/jl-13-power-potion-back.png": 487714,
	"./jaws-of-the-lion/1-13/jl-13-power-potion.png": 672660,
	"./jaws-of-the-lion/14/jl-14-mana-potion-back.png": 493606,
	"./jaws-of-the-lion/14/jl-14-mana-potion.png": 322605,
	"./jaws-of-the-lion/15-20/jl-15-amulet-of-life-back.png": 969039,
	"./jaws-of-the-lion/15-20/jl-15-amulet-of-life.png": 373721,
	"./jaws-of-the-lion/15-20/jl-16-robes-of-evocation-back.png": 897469,
	"./jaws-of-the-lion/15-20/jl-16-robes-of-evocation.png": 248471,
	"./jaws-of-the-lion/15-20/jl-17-comfortable-shoes-back.png": 408518,
	"./jaws-of-the-lion/15-20/jl-17-comfortable-shoes.png": 325948,
	"./jaws-of-the-lion/15-20/jl-18-battle-axe-back.png": 97023,
	"./jaws-of-the-lion/15-20/jl-18-battle-axe.png": 62858,
	"./jaws-of-the-lion/15-20/jl-19-black-candle-back.png": 420789,
	"./jaws-of-the-lion/15-20/jl-19-black-candle.png": 105007,
	"./jaws-of-the-lion/15-20/jl-20-stun-powder-back.png": 532716,
	"./jaws-of-the-lion/15-20/jl-20-stun-powder.png": 8334,
	"./jaws-of-the-lion/21-26/jl-21-hawk-helm-back.png": 615638,
	"./jaws-of-the-lion/21-26/jl-21-hawk-helm.png": 266338,
	"./jaws-of-the-lion/21-26/jl-22-bladed-armor-back.png": 299986,
	"./jaws-of-the-lion/21-26/jl-22-bladed-armor.png": 45063,
	"./jaws-of-the-lion/21-26/jl-23-boots-of-striding-back.png": 145698,
	"./jaws-of-the-lion/21-26/jl-23-boots-of-striding.png": 206986,
	"./jaws-of-the-lion/21-26/jl-24-volatile-bomb-back.png": 750987,
	"./jaws-of-the-lion/21-26/jl-24-volatile-bomb.png": 165254,
	"./jaws-of-the-lion/21-26/jl-25-barbed-chain-back.png": 635374,
	"./jaws-of-the-lion/21-26/jl-25-barbed-chain.png": 511377,
	"./jaws-of-the-lion/21-26/jl-26-oak-charm-back.png": 729438,
	"./jaws-of-the-lion/21-26/jl-26-oak-charm.png": 936570,
	"./jaws-of-the-lion/27-36/jl-27-fateful-compass-back.png": 280353,
	"./jaws-of-the-lion/27-36/jl-27-fateful-compass.png": 858245,
	"./jaws-of-the-lion/27-36/jl-28-flea-bitten-shawl-back.png": 457057,
	"./jaws-of-the-lion/27-36/jl-28-flea-bitten-shawl.png": 782755,
	"./jaws-of-the-lion/27-36/jl-29-tower-shield-back.png": 186218,
	"./jaws-of-the-lion/27-36/jl-29-tower-shield.png": 421001,
	"./jaws-of-the-lion/27-36/jl-30-ring-of-haste-back.png": 349877,
	"./jaws-of-the-lion/27-36/jl-30-ring-of-haste.png": 942097,
	"./jaws-of-the-lion/27-36/jl-31-ring-of-strength-back.png": 676017,
	"./jaws-of-the-lion/27-36/jl-31-ring-of-strength.png": 3301,
	"./jaws-of-the-lion/27-36/jl-32-ring-of-restoration-back.png": 379578,
	"./jaws-of-the-lion/27-36/jl-32-ring-of-restoration.png": 452907,
	"./jaws-of-the-lion/27-36/jl-33-steel-ring-back.png": 413966,
	"./jaws-of-the-lion/27-36/jl-33-steel-ring.png": 631491,
	"./jaws-of-the-lion/27-36/jl-34-barbed-axe-back.png": 457133,
	"./jaws-of-the-lion/27-36/jl-34-barbed-axe.png": 914457,
	"./jaws-of-the-lion/27-36/jl-35-robes-of-command-back.png": 897784,
	"./jaws-of-the-lion/27-36/jl-35-robes-of-command.png": 978974,
	"./jaws-of-the-lion/27-36/jl-36-jet-boots-back.png": 128965,
	"./jaws-of-the-lion/27-36/jl-36-jet-boots.png": 222074,
	"./trail-of-ashes/toa-101-runic-visard-back.png": 732525,
	"./trail-of-ashes/toa-101-runic-visard.png": 947533,
	"./trail-of-ashes/toa-102-shoes-of-ataraxy-back.png": 730200,
	"./trail-of-ashes/toa-102a-shoes-of-ataraxy.png": 416467,
	"./trail-of-ashes/toa-102b-shoes-of-ataraxy.png": 862171,
	"./trail-of-ashes/toa-103-magnetic-relocator-back.png": 196039,
	"./trail-of-ashes/toa-103-magnetic-relocator.png": 247207,
	"./trail-of-ashes/toa-104-shepherds-flute-back.png": 367497,
	"./trail-of-ashes/toa-104-shepherds-flute.png": 436770,
	"./trail-of-ashes/toa-105-tyrannical-staff-back.png": 106198,
	"./trail-of-ashes/toa-105-tyrannical-staff.png": 816835,
	"./trail-of-ashes/toa-106-crushing-mace-back.png": 492168,
	"./trail-of-ashes/toa-106a-crushing-mace.png": 731283,
	"./trail-of-ashes/toa-106b-crushing-mace.png": 207811,
	"./trail-of-ashes/toa-107-chiefs-garb-back.png": 505153,
	"./trail-of-ashes/toa-107-chiefs-garb.png": 202786,
	"./trail-of-ashes/toa-108-iridescent-bracer-back.png": 463225,
	"./trail-of-ashes/toa-108-iridescent-bracer.png": 756974,
	"./trail-of-ashes/toa-109-talos-staff-back.png": 523162,
	"./trail-of-ashes/toa-109-talos-staff.png": 573073,
	"./trail-of-ashes/toa-110-mask-of-cruelty-back.png": 267078,
	"./trail-of-ashes/toa-110-mask-of-cruelty.png": 399467,
	"./trail-of-ashes/toa-111-staff-of-equilibrium-back.png": 573413,
	"./trail-of-ashes/toa-111-staff-of-equilibrium.png": 702793,
	"./trail-of-ashes/toa-112-voyagers-blade-back.png": 121548,
	"./trail-of-ashes/toa-112-voyagers-blade.png": 321155,
	"./trail-of-ashes/toa-113-looking-glass-back.png": 328343,
	"./trail-of-ashes/toa-113-looking-glass.png": 418420,
	"./trail-of-ashes/toa-114-runic-boots-of-travel-back.png": 250709,
	"./trail-of-ashes/toa-114-runic-boots-of-travel.png": 842818,
	"./trail-of-ashes/toa-115-battle-standard-back.png": 390197,
	"./trail-of-ashes/toa-115-battle-standard.png": 75226,
	"./trail-of-ashes/toa-116-matriarchs-warhorn-back.png": 914353,
	"./trail-of-ashes/toa-116-matriarchs-warhorn.png": 289241,
	"./trail-of-ashes/toa-117-dawnbloom-nectar-back.png": 179697,
	"./trail-of-ashes/toa-117a-dawnbloom-nectar.png": 933676,
	"./trail-of-ashes/toa-117b-dawnbloom-nectar.png": 995381,
	"./trail-of-ashes/toa-118-graveweed-extract-back.png": 107184,
	"./trail-of-ashes/toa-118a-graveweed-extract.png": 87903,
	"./trail-of-ashes/toa-118b-graveweed-extract.png": 619074,
	"./trail-of-ashes/toa-119-thrice-souled-warsword-back.png": 629784,
	"./trail-of-ashes/toa-119-thrice-souled-warsword.png": 424157,
	"./trail-of-ashes/toa-120-rekindled-core-back.png": 146856,
	"./trail-of-ashes/toa-120-rekindled-core.png": 916492,
	"./trail-of-ashes/toa-121-crystal-catalyst-back.png": 388589,
	"./trail-of-ashes/toa-121-crystal-catalyst.png": 98631,
	"./trail-of-ashes/toa-122-crystal-spike-back.png": 883579,
	"./trail-of-ashes/toa-122-crystal-spike.png": 654687,
	"./trail-of-ashes/toa-123-arclight-cladding-back.png": 136338,
	"./trail-of-ashes/toa-123-arclight-cladding.png": 616724,
	"./trail-of-ashes/toa-124-arcbolt-lance-back.png": 211150,
	"./trail-of-ashes/toa-124-arcbolt-lance.png": 931736,
	"./trail-of-ashes/toa-125-scroll-of-evasion-back.png": 150095,
	"./trail-of-ashes/toa-125-scroll-of-evasion.png": 390443,
	"./trail-of-ashes/toa-126-arcstone-greaves-back.png": 680251,
	"./trail-of-ashes/toa-126-arcstone-greaves.png": 740009,
	"./trail-of-ashes/toa-127-arclight-hood-back.png": 305734,
	"./trail-of-ashes/toa-127-arclight-hood.png": 642275,
	"./trail-of-ashes/toa-128-barbed-whip-back.png": 286010,
	"./trail-of-ashes/toa-128-barbed-whip.png": 439066,
	"./trail-of-ashes/toa-129-talos-rosary-back.png": 673605,
	"./trail-of-ashes/toa-129a-talos-rosary.png": 39522,
	"./trail-of-ashes/toa-129b-talos-rosary.png": 158271,
	"./trail-of-ashes/toa-130-dynamic-sickle-back.png": 850636,
	"./trail-of-ashes/toa-130-dynamic-sickle.png": 309467,
	"./trail-of-ashes/toa-131-predators-wristblade-back.png": 683193,
	"./trail-of-ashes/toa-131-predators-wristblade.png": 114828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198146;